// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

window.forceClearModalBackdrop = function() {
  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open').css({ overflow: '', paddingRight: '' });
};

window.clearStaleModalBackdrop = function() {
  window.setTimeout(function() {
    if ($('.modal.show').length > 0) return;
    window.forceClearModalBackdrop();
  }, 350);
};

$(function() {
  $(document).off('hidden.bs.modal.clearStaleBackdrop').on('hidden.bs.modal.clearStaleBackdrop', '.modal', function() {
    window.clearStaleModalBackdrop();
  });

  $('.js-flash-msg-area').each(function() {
    var $flash = $(this);
    var delay = $flash.hasClass('alert-danger') ? 5000 : 3000;
    setTimeout(function () {
      $flash.fadeOut('fast');
    }, delay);
  });

  var contractChangeSavedToast = sessionStorage.getItem("contractChangeSavedToast");
  if (contractChangeSavedToast) {
    sessionStorage.removeItem("contractChangeSavedToast");
    var $toast = $('<div class="contract-change-toast" role="status"></div>').text(contractChangeSavedToast);
    $('body').append($toast);
    setTimeout(function () {
      $toast.fadeOut('fast', function () {
        $toast.remove();
      });
    }, 5000);
  }
});

function validityPeriodDateValue(label, baseDateValue) {
  var match = String(baseDateValue || '').match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
  var baseDate = new Date();

  if (match) {
    baseDate = new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10));
  }

  if (label === '1週間') baseDate.setDate(baseDate.getDate() + 7);
  if (label === '2週間') baseDate.setDate(baseDate.getDate() + 14);
  if (label === '1ヶ月') baseDate = addMonthsClamped(baseDate, 1);

  var year = baseDate.getFullYear();
  var month = String(baseDate.getMonth() + 1).padStart(2, '0');
  var day = String(baseDate.getDate()).padStart(2, '0');

  return year + '/' + month + '/' + day;
}

function addMonthsClamped(date, months) {
  var targetYear = date.getFullYear();
  var targetMonth = date.getMonth() + months;
  var targetLastDay = new Date(targetYear, targetMonth + 1, 0).getDate();
  var targetDay = Math.min(date.getDate(), targetLastDay);

  return new Date(targetYear, targetMonth, targetDay);
}

function syncValidityPeriodOption(option) {
  var $option = $(option);
  var $field = $option.closest('.validity-period-field');
  var formPrefix = $option.attr('name').replace(/_expired_at_option$/, '');
  var dateValue = validityPeriodDateValue($option.val(), $('#' + formPrefix + '_sheet_made_at').val());
  var $expiredAt = $field.find('.js-expired-at-date');

  $field.find('.js-expired-at-text').val($option.val());
  $expiredAt.val(dateValue).trigger('change');

  var picker = $expiredAt.data('daterangepicker');
  if (picker) {
    picker.setStartDate(dateValue);
    picker.setEndDate(dateValue);
  }
  $field.find('.clear-icon').css('display', 'inline');
}

window.validityPeriodDateValue = validityPeriodDateValue;
window.syncValidityPeriodOption = syncValidityPeriodOption;

$(window).on('resize', function () {
  var win = $(this); //this = window
  swapWorkerFormBoxs();
  if (win.width() < 992) {
    swapWorkerFormFields();
  }
});

// function initSidebarMenuState() {
//   let current_location = location.href;
//   let elements = $('.sidebar').find('.s-item');

//   for (let i = 0; i < elements.length; i++) {
//     let dropdown_content_items = $(elements[i]).find('.sidebar-dropdown-container ul li');
//     let $dropdown_btn = $(elements[i]).find('.sidebar-dropdown-btn.level-1');

//     for (let j = 0; j < dropdown_content_items.length; j++) {
//       let item = dropdown_content_items[j];
//       let item_href = $(item).find('a').attr('href');

//       if (current_location.indexOf(item_href) != -1) {
//         openSidebarItemState($dropdown_btn);

//         return false;
//       }
//     }
//   }
// }

function initSidebarMenuState() {
  let current_location = location.href;
  let level2_buttons = $('.sidebar-dropdown-btn.level-2');

  level2_buttons.each(function() {
    const $level2Btn = $(this);
    const $level2Container = $level2Btn.next('.sidebar-dropdown-container');
    const $level2Links = $level2Container.find('a');

    $level2Links.each(function() {
      const href = $(this).attr('href');
      if (current_location.includes(href)) {
        openSidebarItemState($level2Btn);

        const $level1Btn = $level2Btn.closest('.sidebar-dropdown-container') // level-1 container
          .prev('.sidebar-dropdown-btn.level-1');     // find its corresponding btn
        openSidebarItemState($level1Btn);

        return false;
      }
    });
  });
}

function swapWorkerFormBoxs() {
  const employeeSection = document.querySelector('.form-workers-page .second-box-wrapper');
  const personalSection = document.querySelector('.form-workers-page .third-box-wrapper');
  const employeeColumn = document.querySelector('.form-workers-page .second-box-area');
  const personalColumn = document.querySelector('[data-worker-personal-column]');
  if (!employeeSection || !personalSection || !employeeColumn || !personalColumn) return;

  // Move the original nodes so form state and bound events survive resizing.
  const mobile = window.innerWidth < 992;
  const employeeTarget = mobile ? personalColumn : employeeColumn;
  const personalTarget = mobile ? employeeColumn : personalColumn;
  if (employeeSection.parentElement !== employeeTarget) employeeTarget.append(employeeSection);
  if (personalSection.parentElement !== personalTarget) personalTarget.append(personalSection);
}

function swapWorkerFormFields() {
  let secondbox_col6_1 = $($('.form-workers-page .second-box-wrapper .row .col-6')[1]);
  let secondbox_col6_2 = $($('.form-workers-page .second-box-wrapper .row .col-6')[2]);

  swapPosition2Boxs(secondbox_col6_1, secondbox_col6_2);

  let secondbox_col6_0 = $($('.form-workers-page .second-box-wrapper .row .col-6')[0]);
  let secondbox_col6_4 = $($('.form-workers-page .second-box-wrapper .row .col-6')[4]);

  secondbox_col6_0.insertBefore(secondbox_col6_4);
}

$(document).on('click', '.js-sp-menu-icon', function(e) {
  e.preventDefault();

  sp_sidebar_open();
});

$(document).on('click', '.overlay, .sp-sidebar-head-close', function(e) {
  e.preventDefault();

  sp_sidebar_close();
});

$(document).on('click', '.workers-page .sp-head-filter-icons .btn-search', function(e) {
  e.preventDefault();

  $filter_workers_area = $(this).parents('.workers-page').find('.filter-workers-area');

  if ($($filter_workers_area).hasClass('d-none')) {
    $($filter_workers_area).removeClass('d-none');
  } else {
    $($filter_workers_area).addClass('d-none');
  }
});

$(document).on('click', '.btn-reset', function(e) {
  var elements = $(this).parents('form .card').find('input');
  var select_elements = $(this).parents('form .card').find('select');

  for (var i = 0; i < elements.length; i++) {
    if (
      elements[i].type == 'text' ||
      elements[i].type == 'email' ||
      elements[i].type == 'password' ||
      elements[i].type == 'number' ||
      elements[i].type == 'tel'
    ) {
      elements[i].value = '';
    }
  }

  for (var i = 0; i < select_elements.length; i++) {
    select_elements[i].value = '';
  }
});

function swapPosition2Boxs(div1, div2) {
  tdiv1 = div1.clone();
  tdiv2 = div2.clone();

  if (!div2.is(':empty')) {
    div1.replaceWith(tdiv2);
    div2.replaceWith(tdiv1);
  }
}

// $(document).on('click', '.sidebar-dropdown-btn', function (e) {
//   e.stopPropagation(); // Ngăn click lan lên cha

//   const $this = $(this);

//   // Đóng tất cả menu khác cùng cấp
//   const siblingItems = $this.closest('ul').find('> li > .sidebar-dropdown-btn').not($this);
//   siblingItems.each(function () {
//     if ($(this).hasClass('active')) {
//       closeSidebarItemState($(this));
//     }
//   });

//   // Toggle hiện tại
//   handleSidebarMenuState($this);
// });

$(document).on('click', '.sidebar-dropdown-btn.level-1', function(e) {
  e.stopPropagation();

  const $this = $(this);

  $('.sidebar-dropdown-btn.level-1').not($this).each(function() {
    closeSidebarItemState($(this));
  });

  handleSidebarMenuState($this);
});

$(document).on('click', '.sidebar-dropdown-btn.level-2', function(e) {
  e.stopPropagation();

  const $this = $(this);

  $this.closest('ul').find('> li > .sidebar-dropdown-btn.level-2').not($this).each(function() {
    closeSidebarItemState($(this));
  });

  handleSidebarMenuState($this);
});

function closeSidebarItemState($object) {
  $($object).removeClass('active');

  $($($object).find('img')[0]).removeClass('filter-c-blue');
  $($($object).find('span.float-end img')[0]).addClass('filter-c-chevron-left');
  $($($object).find('span.float-end img')[0]).removeClass('rotated-180');
  $($($object).find('span.float-end img')[0]).addClass('rotated-90');

  let dropdownContent = $($object).siblings('.sidebar-dropdown-container')[0];

  $(dropdownContent).hide('slow');
}

function openSidebarItemState($object) {
  $($object).addClass('active');

  $($($object).find('img')[0]).addClass('filter-c-blue');
  $($($object).find('span.float-end img')[0]).removeClass('filter-c-chevron-left');
  $($($object).find('span.float-end img')[0]).removeClass('rotated-90');
  $($($object).find('span.float-end img')[0]).addClass('rotated-180');

  let dropdownContent = $($object).siblings('.sidebar-dropdown-container')[0];

  $(dropdownContent).show('slow');
}

$(document).on('click', '#search_zipcode', function() {
  let zipcode = $('#zipcode').val();

  $.ajax({
    url: '/main_companies/find_zipcode',
    data: { zipcode: zipcode },
    method: 'get',
    dataType: 'json',
    success: function(res) {
      if (res.status) {
        $('#address1').val(res.data.prefecture + res.data.city + res.data.town);
        $('.client_company_company_zipcode').find('.help-block').remove();
        $('.client_company_company_zipcode').removeClass('has-error');
      } else {
        $('.client_company_company_zipcode').addClass('has-error');
        $('.client_company_company_zipcode').find('.help-block').remove();
        $('.client_company_company_zipcode').append('<span class="help-block">入力された郵便番号が存在しません。再度確認してください。</span>');
        $('#zipcode').val('');
      }
    },
  });
});


function handleSidebarMenuState($this) {
  if ($($this).hasClass('active')) {
    $($this).removeClass('active');

    $($($this).find('img')[0]).removeClass('filter-c-blue');
    $($($this).find('span.float-end img')[0]).addClass('filter-c-chevron-left');
    $($($this).find('span.float-end img')[0]).removeClass('rotated-180');
    $($($this).find('span.float-end img')[0]).addClass('rotated-90');
  } else {
    $($this).addClass('active');

    $($($this).find('img')[0]).addClass('filter-c-blue');
    $($($this).find('span.float-end img')[0]).removeClass('filter-c-chevron-left');
    $($($this).find('span.float-end img')[0]).removeClass('rotated-90');
    $($($this).find('span.float-end img')[0]).addClass('rotated-180');
  }

  let dropdownContent = $($this).siblings('.sidebar-dropdown-container')[0];

  if ($(dropdownContent).css('display') === 'block') {
    $(dropdownContent).hide('slow');
  } else {
    $(dropdownContent).show('slow');
  }
}

window.addYearSuffix = function(picker) {
  $(picker.container).find('.yearselect option').each(function() {
    const val = $(this).val();
    if (!$(this).text().includes('年')) {
      $(this).text(val + '年');
    }
  });
};

window.reorderYearMonth = function(picker) {
  const container = $(picker.container);
  container.find('.drp-calendar').each(function() {
    const $cal = $(this);
    const $month = $cal.find('.monthselect').first();
    const $year = $cal.find('.yearselect').first();

    if ($month.length && $year.length) {
      if ($month.index() < $year.index()) {
        $year.insertBefore($month);
      }
      $month.addClass('ms-2');
    }
  });
};

function syncDeliverAtFilterControls(options) {
  const $dateInput = $('#filter_deliver_at');
  const $checkbox = $('#deliver-at-present');
  if (!$dateInput.length || !$checkbox.length) return;

  const enabled = $checkbox.is(':checked');
  $dateInput.prop('disabled', !enabled);

  const $clearIcon = $dateInput.closest('.input-clearable').find('.clear-icon');
  const picker = $dateInput.data('daterangepicker');

  if (!enabled) {
    if (options && options.clearDate) {
      $dateInput.val('');
    }
    $clearIcon.hide();
    if (picker) picker.hide();
  } else if ($dateInput.val().trim() !== '') {
    $clearIcon.css('display', 'inline');
  }
}

function initDateRangePicker() {
  $('input.singledate').daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
    showDropdowns: true,
  }).on('showCalendar.daterangepicker', function(ev, picker) {
    addYearSuffix(picker);
    reorderYearMonth(picker);

  });

  $('input.singledate').on('show.daterangepicker', function (ev, picker) {
    if ($(this).prop('disabled')) {
      picker.hide();
    }
  });

  $('input.singledate').on('apply.daterangepicker', function (ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    $(this).val(picker.startDate.format(format));
    if ($(this).hasClass('input-sheet-made') && typeof window.syncValidityPeriodFromSheetMadeAtInput === 'function') {
      window.syncValidityPeriodFromSheetMadeAtInput(this);
    }
    syncRepresentativeBirthdayFromPicker($(this), picker);
    if (this.id === 'filter_deliver_at') {
      const clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
      clearIcon.css('display', this.value ? 'inline' : 'none');
      syncDeliverAtFilterControls();
    }
  });

  $('input.singledate').on('cancel.daterangepicker', function (ev, picker) {
    $(this).val('');
    if ($(this).hasClass('js-representative-birthday')) {
      window.validateRepresentativeBirthday($(this), '');
    }

    if (this.id === 'filter_deliver_at') {
      $(this).closest('.input-clearable').find('.clear-icon').hide();
      syncDeliverAtFilterControls();
    }
  });

  let names = [
    'daterange',
    'daterange_birthdate',
    'daterange_join_at',
    'daterange_leave_at',
    'daterange_used_at',
    'daterange_submitted_at',
    'ordered_at',
    'transfer_date',
    'sheet_made_at',
    'deposit_date',
    'bill_date',
    'payment_limit_at',
    'daterange_contracted_at',
    'daterange_estimated_deliver_at',
    'daterange_start_at',
    'created_at',
    'created_at_ranger',
    'estimated_delivery_at',
    'acceptance_date',
  ];
  names.forEach((name) => {
    initDateRangeByName(name);
  });
}

function parseYmdDate(value) {
  if (!value) return null;

  const match = String(value).match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
  if (!match) return null;

  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

window.isRepresentativeBirthdayInFuture = function(value) {
  const date = parseYmdDate(value);
  if (!date || Number.isNaN(date.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date > today;
};

window.validateRepresentativeBirthday = function($input, value) {
  $input = $($input);
  if (!$input.length) return true;

  const dateValue = value !== undefined ? value : $input.val();
  const $wrap = $input.closest('.js-representative-birthday-wrap');
  const $error = $wrap.find('.js-representative-birthday-error');
  const invalid = window.isRepresentativeBirthdayInFuture(dateValue);

  $wrap.toggleClass('has-error', invalid);
  $input.toggleClass('is-invalid', invalid);
  if (invalid) {
    $error.removeClass('d-none').css('display', 'block');
  } else {
    $error.addClass('d-none').css('display', '');
  }
  return !invalid;
};

function syncRepresentativeBirthdayFromPicker($input, picker) {
  if (!$input.hasClass('js-representative-birthday')) return;

  const value = picker && picker.startDate ? picker.startDate.format('YYYY/MM/DD') : $input.val();
  window.validateRepresentativeBirthday($input, value);
}

$(document).on('apply.daterangepicker', '.js-representative-birthday', function(ev, picker) {
  const value = picker && picker.startDate ? picker.startDate.format('YYYY/MM/DD') : $(this).val();
  window.validateRepresentativeBirthday($(this), value);
});

$(document).on('change', '.js-representative-birthday', function() {
  window.validateRepresentativeBirthday($(this));
});

$(document).on('submit', 'form', function(e) {
  const $input = $(this).find('.js-representative-birthday');
  if (!$input.length) return;
  if (!window.validateRepresentativeBirthday($input)) {
    e.preventDefault();
    $input[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});

function sp_sidebar_open() {
  $('#main-body-sidebar').removeClass('d-none');
  $('body').addClass('noscroll');
  $('.overlay').removeClass('d-none');
}

function sp_sidebar_close() {
  $('#main-body-sidebar').addClass('d-none');
  $('.overlay').addClass('d-none');
  $('body').removeClass('noscroll');
}

$(document).on('click', '.js-search-projects-btn', function(e) {
  $('.js-projects-search-btn-submit').trigger('click');
});

$(document).on('click', '.remove_fields', function(event) {
  $(this).closest('.nested-fields').find('.upload-file').remove();
  return checkSizeDataUpload();
});

$(document).on('change', '.upload-file', function(event) {
  $('#remove_file_worker').removeClass('hidden');
  let preview = $(this).closest('.nested-fields').find('.show-file-name');
  let input = $(event.currentTarget);
  let file = input[0].files[0];
  $('.button-file').addClass('d-none');
  preview.removeClass('d-none');
  preview.val(file.name);
  checkSizeDataUpload();
  checkSizeDataUploadWorker();
});

function checkSizeDataUpload() {
  let total_size_data_uploaded = 0;
  $('.upload-file').each(function(event) {
    let upload_file = $(this)[0].files[0];
    let size = upload_file.size;
    total_size_data_uploaded += size;
  });

  if (total_size_data_uploaded / 1000000 > 100) {
    $('#error_limit_file_upload').removeClass('d-none');
    $('#submit_form_new').prop('disabled', true);
  } else {
    $('#error_limit_file_upload').addClass('d-none');
    $('#submit_form_new').prop('disabled', false);
  }
}

function checkSizeDataUploadWorker() {
  let total_size_data_uploaded = 0;
  $('.upload-file').each(function(event) {
    let upload_file = $(this)[0].files[0];
    let size = upload_file.size;
    total_size_data_uploaded += size;
  });

  if (total_size_data_uploaded / 1000000 > 1) {
    $('#error_limit_file_upload').removeClass('d-none');
    $('#submit_form_worker').prop('disabled', true);
  } else {
    $('#error_limit_file_upload').addClass('d-none');
    $('#submit_form_worker').prop('disabled', false);
  }
}

function restorePartnerCompanySelect2() {
  $('.estimate-ordered-item-company-id, .estimate-sheet-company-id').each(function() {
    var $select = $(this);
    if (!$select.data('select2')) return;

    var ids = $select.data('selectedCompanies');
    if (!ids) {
      ids = $select.closest('.nested-fields')
        .find('.order-details-body tr:not(.hidden) input.company_partner_id, .order-details-body tr:not(.hidden) input[name*="[company_id]"][type="hidden"]')
        .map(function() {
          return $(this).val();
        })
        .get()
        .filter(Boolean)
        .join(',');
    }

    if (ids) {
      $select.val(String(ids).split(',')).trigger('change');
    }
  });
}

function initSelect2() {
  $('.select2').select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    language: {
      noResults: function() {
        return '見つかりません。';
      },
    },
  });

  restorePartnerCompanySelect2();

  // hide select closing_day_lease if
  if ($('#closing_day_lease').css('display') == 'none') {
    $('#closing_day_lease').next('.select2-container').hide();
  } else if ($('#closing_day_client').css('display') == 'none') {
    $('#closing_day_client').next('.select2-container').hide();
  }

  // $('.select2_without_placeholder').select2({
  //   width: '100%',
  //   theme: 'bootstrap',
  //   allowClear: true,
  //   language: {
  //     noResults: function () {
  //       return '見つかりません。';
  //     },
  //   },
  // });

  let selectorId = 'assigned_worker_id';

  $('#' + selectorId).attr('multiple', 'multiple');
  if ($('#' + selectorId + ' option')[0]) $('#' + selectorId + ' option')[0].remove();

  $('#' + selectorId).select2({
    multiple: true,
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    language: {
      noResults: function() {
        return '見つかりません。';
      },
    },
  });

  if ($('.select2').hasClass('has-error')) {
    $('.select2-container--bootstrap .select2-selection--single').addClass('has-error');
  }
}

function initDateRangeByName(name) {
  const $inputs = $(`input[name="${name}"]`).filter(function () {
    return this.type !== 'hidden';
  });

  $inputs.daterangepicker({
    locale: ja_date_locale,
    autoUpdateInput: false,
    autoApply: true,
    allowEndDateFirst: true,
  });

  $inputs.on('apply.daterangepicker', function(ev, picker) {
    $(this).val(
      picker.startDate.format('YYYY/MM/DD') + ' ~ ' + picker.endDate.format('YYYY/MM/DD'),
    );
    var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
    clearIcon.css('display', this.value ? 'inline' : 'none');
  });

  $inputs.on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });
}

$(document).on('click', '#sheet_made_at', function(event) {
  $('.drp-buttons').css('display', 'block');
  $('.drp-selected').css('display', 'none');
  $('.applyBtn').css('display', 'none');
  $('.cancelBtn').css('color', '#2674ff');
  $('.cancelBtn').css('background', 'white');
});

$(document).on('click', '#checkAll', function(event) {
  $('.check').prop('checked', $(this).prop('checked'));
});

$(document).on('change', '#model_id', function(event) {
  let maker_id = $('.js-select-maker').find(':selected').text();
  let object_lease_type_id = $('#object_lease_type_id').find(':selected').text();
  let model_id = $('.js-select-model').find(':selected').text();
  $('#name').prop('readonly', true);
  $('#name').val(maker_id + object_lease_type_id + model_id);
});

$(document).on('click', '.add_fields', function(event) {
  // Daily report manages its own Select2/cascade — do not re-init globally
  // (re-running initSelect2/initDateRangePicker clears selected values).
  if ($(this).closest('#daily-report-form, #form-edit-daily-report').length ||
    $('#new-daily-report-form').length && $(this).closest('#dr-add-row-wrap').length) {
    return;
  }

  // set timeout to wait for rails to add the new fields
  setTimeout(function() {
    initDateRangePicker();
    initSelect2();
    if ($('#project_id').val() != '') {
      $('.order_sheet_project_id .select2-container--bootstrap .select2-selection--single').css('background', '#dddddd');
    }
  }, 50);
  const element = document.getElementById('add_file_worker');
  if (element) {
    $('.add_fields').addClass('hidden');
    $('.upload-file').click();
    $('#remove_file_worker').addClass('hidden');
  }
});

$(document).on('click', '.remove_fields', function(event) {
  const element = document.getElementById('remove_file_worker');
  const nested_fields = $(event.target).closest('.nested-fields');
  if (element) {
    $('.add_fields').removeClass('hidden');
  } else if (nested_fields.length > 0) {
    $(nested_fields).hide();
  }
});

$(document).on('click', '.btn-edit-file', function(e) {
  const fileId = $(this).closest('.upload-item').children('.file-id');
  const fileName = $(this).closest('.upload-item').children('.file-name');
  const fileInput = $(this).closest('.upload-item').children('.file-name-input');
  if (fileName.length > 0) {
    const value = fileName.html();
    fileName.replaceWith(`<input class="form-control file-name-input" value="${value}">`);
  } else {
    const value = fileInput.val();
    fileInput.replaceWith(`<span class='file-name'>${value}</span>`);
  }
  if (fileInput.val()) {
    $.ajax({
      url: '/estimate_sheets/update_file_name',
      method: 'PUT',
      data: { file_id: fileId.text(), file_name: fileInput.val() },
      success: function(res) {
        // window.location = '/estimate_sheets';
      },
    });
  }
});

$(document).on('change', '.upload-files', function(event) {
  let parent = $(this).closest('.text-body');
  let input = $(event.currentTarget);
  let files = input[0].files;
  for (let i = 0; i < files.length; i++) {
    let obj = files[i];
    parent.prepend(
      `<div class="nested-fields expense-file-inline ${
        obj.lastModified
      }"><div class="d-flex"><a target="_blank" href="#"> ${obj.name.substring(
        0,
        10,
      )}</a><input value="false" type="hidden" name="expense[accept_files][${i}][_destroy]" id="expense_files_${i}__destroy"><a class="ms-3 close remove_fields existing" href="#" data-remote="true"><span aria-hidden="true">×</span></a></div></div>`,
    );
  }
});

$('input.singledate').on('apply.daterangepicker', function(ev, picker) {
  let format = $(this).data('format') || 'YYYY/MM/DD';
  $(this).val(picker.startDate.format(format));
});

$(document).on('change', 'input[data-toggle-accepting]', function(event) {
  $($(event.target).closest('.wrap-expand-arrow').find('div[data-accepting-area]').first()).toggleClass('hidden');
});

$(document).on('change', '[data-expired-at]', function(event) {
  $($(event.target).closest('.wrap-expand-arrow').find('div[data-accepting-area]').first()).toggleClass('hidden');
});

$(document).on('click', '#choose-ordered-item-submit', function(event) {
  event.preventDefault();

  var $button = $(this);
  if ($button.data('submitting')) {
    return;
  }
  $button.data('submitting', true);
  $button.prop('disabled', true);

  var isInvalid = false;
  var $productName = $('#modal-choose-ordered-item .js-product-text');
  var $productQuantity = $('#modal-choose-ordered-item .js-amount');
  var $productUnitPrice = $('#modal-choose-ordered-item .js-unit');
  var $contractStartDate = $('#modal-choose-ordered-item #contract_start_date');
  var $account = $('#modal-choose-ordered-item #ordered_item_account');
  var categoryType = $('.category-product').html();
  var $unitPrice = $('.js-unit-price');
  $account.val(($account.val() || '').trim());

  $('#modal-choose-ordered-item .error-message-uniq').addClass('hidden');
  $('#modal-choose-ordered-item .error-message-account-uniq').addClass('hidden');
  $('#modal-choose-ordered-item .error-message-date-order').addClass('hidden');
  $('#modal-choose-ordered-item .error-message').addClass('hidden');

  if ($unitPrice.val() == '') {
    isInvalid = true;
    $unitPrice.addClass('is-invalid');
    $('#modal-choose-ordered-item .error-message').removeClass('hidden');
    $(this).prop('disabled', false);
  }

  if ($productName.val() == '') {
    isInvalid = true;
    $productName.addClass('is-invalid');
    $('#modal-choose-ordered-item .error-message').removeClass('hidden');
    $(this).prop('disabled', false);
  }

  if ($contractStartDate.val() == '') {
    isInvalid = true;
    $contractStartDate.addClass('is-invalid');
    $('#modal-choose-ordered-item .error-message').removeClass('hidden');
    $(this).prop('disabled', false);
  }

  // Unit field is now optional - remove required validation
  $productUnitPrice.removeClass('is-invalid');

  if (categoryType == 'ISP' || categoryType == 'RS') {
    if ($account.val() == '') {
      isInvalid = true;
      $account.addClass('is-invalid');
      $('#modal-choose-ordered-item .error-message').removeClass('hidden');
      $(this).prop('disabled', false);
    }
  } else {
    $account.removeClass('is-invalid');
  }

  // Validate billing_start_month and contract_end_date >= contract_start_date
  // Only run when all required fields are already valid (no other errors)
  var $billingStartMonth = $('#modal-choose-ordered-item #billing_start_month');
  var $contractEndDate = $('#modal-choose-ordered-item #contract_end_date');
  var startDateVal = $contractStartDate.val();
  if (!isInvalid && startDateVal) {
    var startDate = new Date(startDateVal.replace(/\//g, '-'));
    var billingInvalid = false;
    var endDateInvalid = false;

    if ($billingStartMonth.val()) {
      var billingDate = new Date(($billingStartMonth.val() + '/01').replace(/\//g, '-'));

      var startYearMonth = startDate.getFullYear() * 100 + startDate.getMonth();
      var billingYearMonth = billingDate.getFullYear() * 100 + billingDate.getMonth();
      if (billingYearMonth < startYearMonth) {
        billingInvalid = true;
      }
    }

    if ($contractEndDate.val()) {
      var contractEndDate = new Date($contractEndDate.val().replace(/\//g, '-'));
      if (contractEndDate < startDate) {
        endDateInvalid = true;
      }
    }

    if (billingInvalid || endDateInvalid) {
      isInvalid = true;
      var dateErrorMsg = '請求開始年月および契約終了日は、契約開始日以降の日付を指定してください。';
      $('#modal-choose-ordered-item .error-message-date-order').text(dateErrorMsg).removeClass('hidden');
      $button.data('submitting', false);
      $button.prop('disabled', false);
    }
  }

  if ($account.val() != '') {
    var orderItemId = $(this).closest('#modal-choose-ordered-item').find('#ordered_item_id').val();

    $.ajax({
      url: '/ordered_items/check_account',
      method: 'GET',
      data: { account: $account.val(), id: orderItemId },
      success: function(res) {
        if (res.is_exist == true) {
          isInvalid = true;
          $account.addClass('is-invalid');
          $('#modal-choose-ordered-item .error-message-account-uniq').removeClass('hidden');
          $button.data('submitting', false);
          $button.prop('disabled', false);
        } else {
          if (isInvalid) {
            $button.data('submitting', false);
            $button.prop('disabled', false);
            return;
          }

          // Check if contract end date is empty and billing stop checkbox is checked
          var $contractEndDate = $('#modal-choose-ordered-item #contract_end_date');
          var $isPauseCheckbox = $('#modal-choose-ordered-item input[name="ordered_item[is_pause]"]:checkbox');

          if (!$contractEndDate.val() && $isPauseCheckbox.is(':checked')) {
            // Show confirmation dialog
            if (confirm('契約終了日が入力されていませんが、このまま続けてもよろしいですか。')) {
              // User clicked はい (Yes) - proceed with form submission
              $button.closest('#modal-choose-ordered-item').find('form').submit();
            } else {
              // User clicked キャンセル (Cancel) - reset button state
              $button.data('submitting', false);
              $button.prop('disabled', false);
            }
          } else {
            // No validation needed - proceed with normal form submission
            $button.closest('#modal-choose-ordered-item').find('form').submit();
          }
        }
      },
      error: function() {
        alert('Đã xảy ra lỗi khi kiểm tra tài khoản.');
        $button.data('submitting', false);
        $button.prop('disabled', false);
      },
    });
  } else {
    if (isInvalid) {
      $button.data('submitting', false);
      $button.prop('disabled', false);
      return;
    } else {
      // Check if contract end date is empty and billing stop checkbox is checked
      var $contractEndDate = $('#modal-choose-ordered-item #contract_end_date');
      var $isPauseCheckbox = $('#modal-choose-ordered-item input[name="ordered_item[is_pause]"]:checkbox');

      if (!$contractEndDate.val() && $isPauseCheckbox.is(':checked')) {
        // Show confirmation dialog
        if (confirm('契約終了日が入力されていませんが、このまま続けてもよろしいですか。')) {
          // User clicked はい (Yes) - proceed with form submission
          $button.closest('#modal-choose-ordered-item').find('form').submit();
        } else {
          // User clicked キャンセル (Cancel) - reset button state
          $button.data('submitting', false);
          $button.prop('disabled', false);
        }
      } else {
        // No validation needed - proceed with normal form submission
        $button.closest('#modal-choose-ordered-item').find('form').submit();
      }
    }
  }
});

function clearChooseOrderedItemModalState() {
  var $modal = $('#modal-choose-ordered-item');
  var $submitButton = $modal.find('#choose-ordered-item-submit');

  $modal.find('.error-message, .error-message-uniq, .error-message-account-uniq, .error-message-date-order').addClass('hidden');
  $modal.find('.is-invalid, .input-error').removeClass('is-invalid input-error');

  $submitButton.data('submitting', false);
  $submitButton.prop('disabled', false);
}

window.clearChooseOrderedItemModalState = clearChooseOrderedItemModalState;

function resetChooseOrderedItemModal() {
  var $modal = $('#modal-choose-ordered-item');

  $modal.find('form').each(function() {
    this.reset();
  });

  clearChooseOrderedItemModalState();
  $modal.find('.row-content').empty();
}

window.resetChooseOrderedItemModal = resetChooseOrderedItemModal;

// $(document).on('click', "#modal-search-product .btn-choose-product", function (event) {
//   event.preventDefault();
//   if ($('.edit-project-form').length == 0) {
//     return false
//   }

//   const productId = $(this).val();
//   $.ajax({
//     url: '/ordered_items/new',
//     method: 'GET',
//     data: { product_id: productId, project_id: $('#ordered_item_project_id').val() },
//     success: function (res) {
//       $('#modal-search-product').modal("hide");
//     },
//   });
// });
function calculateFees() {
  let total = 0;
  let total_fee = 0;
  let consumption_tax = 0;
  let value;
  $('.nested-fields:not([style*="display: none"]) .js_total_price').each(function() {
    if ($(this).closest('.parent-fields').find('.bill-level-select').length == 0 || ($(this).closest('.parent-fields').find('.bill-level-select').length != 0 && $(this).closest('.parent-fields').find('.bill-level-select').val() === '')) {
      value = parseInt(this.value.replaceAll(',', '')) || 0;
      total += value;

      if (this.hasAttribute('data-free-tax') && $(this).data('free-tax')) {
        total_fee += value;
      } else {
        total_fee += value + value * parseFloat($(this).data('taxt-rate'));
        consumption_tax += value * 0.1;
      }
    }
  });
  consumption_tax = Math.round(consumption_tax);
  total_fee = Math.round(total_fee);
  return { total, total_fee, consumption_tax };
}

// Calculate fees for lease_company: round each item first, then sum, then calculate tax
// This matches Ruby's bill_total_with_tax_lease calculation
// Ruby's custom_round: round to 2 decimals, then round to integer
function customRound(value) {
  if (!value || value === 0) return 0;
  // Round to 2 decimal places first
  const rounded2Decimals = Math.round(value * 100) / 100;
  // Then round to integer
  return Math.round(rounded2Decimals);
}

function calculateFeesLease() {
  let total = 0;
  let total_fee_with_tax = 0;
  let value;
  const taxRate = 0.1; // Default tax rate

  $('.nested-fields:not([style*="display: none"]) .js_total_price').each(function() {
    if ($(this).closest('.parent-fields').find('.bill-level-select').length == 0 || ($(this).closest('.parent-fields').find('.bill-level-select').length != 0 && $(this).closest('.parent-fields').find('.bill-level-select').val() === '')) {
      value = parseInt(this.value.replaceAll(',', '')) || 0;
      total += value;

      if (this.hasAttribute('data-free-tax') && $(this).data('free-tax')) {
        // For free tax items, add value as is
        total_fee_with_tax += value;
      } else {
        // For taxable items: round each item's price with tax first (like Ruby's custom_round)
        const itemTaxRate = parseFloat($(this).data('taxt-rate')) || taxRate;
        const itemWithTax = value * (1 + itemTaxRate);
        // Apply custom_round: round to 2 decimals, then round to integer
        const roundedItemWithTax = customRound(itemWithTax);
        total_fee_with_tax += roundedItemWithTax;
      }
    }
  });

  // Calculate tax as difference between total with tax and total without tax
  const consumption_tax = total_fee_with_tax - total;
  const total_fee = total_fee_with_tax;

  return { total, total_fee, consumption_tax };
}

function calcBillItemsPrice(isChangeTotalTaxDefault = false) {
  updateBillAllPrices();
  $('#modal-create-bill-sheet .bill-item-fields:visible').each(function(index) {
    $(this).find('.js-position').val(index);
  });

  // Use lease calculation method for lease_company and lease_client
  const billType = $('#bill_sheet_bill_type').val();
  const isLease = billType === 'lease_company' || billType === 'lease_client';
  const { total, total_fee, consumption_tax } = isLease ? calculateFeesLease() : calculateFees();

  var total_fee_without_tax = formatCurrency(total);
  var total_fee_display = formatCurrency(total_fee);
  var consumption_tax_display = formatCurrency(consumption_tax);
  $('.js-total-amount').html(total_fee_without_tax);
  $('.js-total_fee_without_tax_pr_coninue').html(total_fee_without_tax);
  $('.ordered_item_total_without_tax').data('value', total);

  $('.js-consumption-tax').html(consumption_tax_display);
  $('.js-total-amount-with-tax').html(total_fee_display);
  $('.js_total_fee_pr_continue').html(total_fee_display);
  if (($('#bill_sheet_is_pay_full').length == 1 && $('#bill_sheet_is_pay_full').prop('checked') == true) || ($('#bill_sheet_is_pay_full').length == 0)) {
    $('#bill_sheet_total_fee_without_tax').val(total.toLocaleString('en-US'));
  }
  $('#bill_sheet_total_fee').val(total_fee.toLocaleString('en-US'));
  calcItemTotalFee(isChangeTotalTaxDefault);
  // let ordered_item_total_with_tax = parseInt($('.ordered_item_total_with_tax').data('value'));
  // if (total > ordered_item_total_with_tax) {
  //   $('.bill-error-msg').removeClass('d-none')
  //   $("#modal-bill-sheet-submit").attr('disabled', true)
  // } else {
  //   $('.bill-error-msg').addClass('d-none')
  //   $("#modal-bill-sheet-submit").attr('disabled', false)
  // }
}

window.calcBillItemsPrice = calcBillItemsPrice;

$(document).on('change', '.js-bill-items .js-amount, .js-bill-items .js-price, .js-bill-items .js-amount, .js-bill-items .js-is-freetax, .bill-level-select', function(event) {
  let isChangeTotalTaxDefault = true;
  if ($(this).hasClass('js-is-freetax')) {
    $(this).closest('.nested-fields').find('.js_total_price').data('free-tax', $(this).is(':checked'));
  }
  let amount = convertToHalf($(this).closest('.nested-fields').find('.js-amount').val().replaceAll(',', '')) || 0;
  let price = convertToHalf($(this).closest('.nested-fields').find('.js-price').val().replaceAll(',', '')) || 0;
  let total = Math.round(parseFloat(amount) * parseFloat(price)) || 0;
  let totalWithTax = Math.round(total * (1 + parseFloat(($(this).closest('.nested-fields').find('.js_total_price').data('taxt-rate'))))) || 0;
  $totalPrice = $(this).closest('.nested-fields').find('.js-total-price span');
  $totalPriceWithTax = $(this).closest('.nested-fields').find('.js-total-price-with-tax span');
  $totalPrice.html('￥ ' + total.toLocaleString('en-US'));
  $totalPriceWithTax.html('￥ ' + totalWithTax.toLocaleString('en-US'));
  $totalPrice.attr('data-value', total);
  $(this).closest('.nested-fields').find('.js_total_price').val(total);

  calcBillItemsPrice(isChangeTotalTaxDefault);
});

$(document).on('click', '.js-btn-ok', function(event) {
  if ($(location).attr('href').split('/').includes('projects') && $(location).attr('href').split('/').includes('edit')) {
    calcBillItemsPrice(true);
  }
});

$(document).on('input', '#ordered_item_unit_price', function(event) {
  update_selling_price(event);
});

function update_selling_price(event) {
  let $form = $(event.target).closest('form');
  let quantityValue = $form.find('#ordered_item_quantity, .js-amount').first().val();
  let unitPriceValue = $form.find('.js-unit-price').val();
  let ordered_item_quantity = parseFloat(String(quantityValue || '').replace(/,/g, ''), 10) || 0;
  let ordered_item_unit_price = parseFloat(convertToHalf(String(unitPriceValue || '').replace(/,/g, ''))) || 0;
  let total = Math.round(ordered_item_quantity * ordered_item_unit_price) || 0;

  const sellingPrice = total >= 0 ? `￥ ${total.toLocaleString('en-US')}` : `- ￥ ${Math.abs(total).toLocaleString('en-US')}`;
  $(event.target).closest('form').find('.js-selling-price').html(sellingPrice);
}

$(document).on('click', '[data-go-order-screen]', function(event) {
  const companyId = $('#modal-choose-order-' + this.getAttribute('data-estimate-sheet')).find('.checkbox-estimate-item:checked').map(function(e) {
    return $(this).data('company-id');
  });

  const leaseCompanyId = $('#modal-choose-order-' + this.getAttribute('data-estimate-sheet')).find('.checkbox-estimate-item:checked').map(function(e) {
    return $(this).data('lease-company-id');
  });


  const typeOfOrderedItem = $('#modal-choose-order-' + this.getAttribute('data-estimate-sheet')).find('.checkbox-estimate-item:checked').map(function(e) {
    return $(this).data('type-of-ordered-item');
  });
  const hasDifferentCompany = Array.from(typeOfOrderedItem).some(item => item === 'company' && Array.from(typeOfOrderedItem).some(item => item === 'lease-company'));

  const projectId = $('[data-project-id]').first().attr('data-project-id');
  const acceptingOrderIds = $('#modal-choose-order-' + this.getAttribute('data-estimate-sheet')).find('.checkbox-estimate-item:checked').map(function(e) {
    return $(this).data('id');
  });
  let arrayCompany = Array.from(companyId);
  let uniqueCompany = [];
  $.each(arrayCompany, function(i, el) {
    if ($.inArray(el, uniqueCompany) === -1) uniqueCompany.push(el);
  });


  let arrayLeaseCompany = Array.from(leaseCompanyId);

  if (JSON.stringify(arrayLeaseCompany) === JSON.stringify([''])) {
    $(this).closest('.modal-body').find('.error-msg').removeClass('d-none').text('該当するリース会社が見つかりませんでした。');
    return false;
  }
  ;

  let uniqueLeaseCompany = [];
  $.each(arrayLeaseCompany, function(i, el) {
    if ($.inArray(el, uniqueLeaseCompany) === -1) uniqueLeaseCompany.push(el);
  });

  if (uniqueCompany.length > 1 || uniqueLeaseCompany.length > 1 || hasDifferentCompany) {
    $(this).closest('.modal-body').find('.error-msg').removeClass('d-none').text('同じ発注先を選択してください。');
    return false;
  } else {
    $(this).closest('.modal-body').find('.error-msg').addClass('d-none');
  }


  $('#modal-choose-order-' + this.getAttribute('data-estimate-sheet')).find('.checkbox-estimate-item:checked').map(function(e) {
    $(this).prop('checked', false);
  });

  location.href = `/order_sheets/new?project_id=${projectId}&lease_company_id=${uniqueLeaseCompany[0] || ''}&company_id=${uniqueCompany[0] || ''}&estimate_ordered_item_company_ids=${acceptingOrderIds.toArray().join(',')}&from_page=project_edit`;
});

$(document).on('shown.bs.modal', '#modal-choose-order', function() {
  $('#modal-choose-order').find('.toggle-check-all-object').prop('checked', false);
});

$(document).on('shown.bs.modal', '.modal-choose-order', function() {
  $('.modal-choose-order').find('.toggle-check-all-object').prop('checked', false);
  $('.modal-choose-order').find('.error-msg').addClass('d-none');
});

$(document).on('hide.bs.modal', '#modal-choose-order', function() {
  $('#modal-choose-order').find('.error-msg').addClass('d-none');
  $('#modal-choose-order').find('#choose_company_id').val('').change();
});

$(document).on('change', '#deliver-at-present', function() {
  syncDeliverAtFilterControls({ clearDate: !$(this).is(':checked') });
});

$(document).on('click', '.input-clearable .clear-icon', function() {
  if ($(this).closest('.input-clearable').find('#filter_deliver_at').length) {
    setTimeout(syncDeliverAtFilterControls, 0);
  }
});

window.addEventListener('DOMContentLoaded', function() {
  $('.js-disabled-input-and-button input').prop('disabled', true);
  $('.js-disabled-input-and-button select').prop('disabled', true);
  $('.js-disabled-input-and-button button').addClass('disabled');

  initDateRangePicker();
  initDateRangePickerMonthYear();
  initSelect2();
  $('.js-representative-birthday').each(function() {
    window.validateRepresentativeBirthday($(this));
  });
  syncDeliverAtFilterControls();
  const element = document.getElementById('show-file-name');
  if (element) {
    $('.add_fields').addClass('hidden');
  }

  let screen_width = $(window).width();
  if (screen_width < 992) {
    swapWorkerFormBoxs();
    swapWorkerFormFields();
  }

  initSidebarMenuState();
});


$(document).on('change', '.convert-half-width', function(event) {
  let valueInput = $(this).val().replace(/,/g, '');

  if (valueInput == '') {
    return;
  }
  let value = parseFloat(convertToHalf(valueInput).toString().replace(/,/g, ''));
  if (isNaN(value)) {
    $(this).val(0);
    return;
  }
  $(this).val(value.toLocaleString('en-US'));
  $(this).trigger('input');
  if ($('.esimate-sheet-page').length > 0) {
    setTimeout(() => {
      estimateSheetCalcTotal();
    }, 300);
  }
  if ($(this).attr('id') == 'ordered_item_quantity') {
    update_selling_price(event);
  }
});

$(document).on('change', '.convert-half-width-text', function() {
  let value = convertToHalfText($(this).val()).trim();
  if ($(this).hasClass('js-zipcode-auto-format')) {
    value = formatZipcode(value);
  }

  $(this).val(value);
  $(this).trigger('input');
});

function convertToHalf(message) {
  let halfwidthValue = message.replace(/[０-９]/g, function(ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
  });
  return Number(halfwidthValue.replace('．', '.').replace(/[−ー－]/g, '-')) || '';
}

function convertToHalfText(message) {
  return message.toString()
    .replace(/[０-９]/g, function(ch) {
      return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
    })
    .replace(/[．。]/g, '.')
    .replace(/[−ー－]/g, '-');
}

function toFullWidthCharacters(value) {
  const halfKana = '｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ';
  const fullKana = '。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン';
  const halfToFullKana = {};
  for (let index = 0; index < halfKana.length; index++) {
    halfToFullKana[halfKana[index]] = fullKana[index];
  }

  const dakuten = {
    カ: 'ガ', キ: 'ギ', ク: 'グ', ケ: 'ゲ', コ: 'ゴ',
    サ: 'ザ', シ: 'ジ', ス: 'ズ', セ: 'ゼ', ソ: 'ゾ',
    タ: 'ダ', チ: 'ヂ', ツ: 'ヅ', テ: 'デ', ト: 'ド',
    ハ: 'バ', ヒ: 'ビ', フ: 'ブ', ヘ: 'ベ', ホ: 'ボ',
    ウ: 'ヴ'
  };
  const handakuten = {
    ハ: 'パ', ヒ: 'ピ', フ: 'プ', ヘ: 'ペ', ホ: 'ポ'
  };

  const text = value == null ? '' : String(value);
  let result = '';

  for (let index = 0; index < text.length; index++) {
    let character = text[index];
    const code = character.charCodeAt(0);

    if (halfToFullKana[character]) {
      character = halfToFullKana[character];
    } else if (character === ' ') {
      character = '　';
    } else if (code >= 0x21 && code <= 0x7e) {
      character = String.fromCharCode(code + 0xfee0);
    }

    const next = text[index + 1];
    if ((next === 'ﾞ' || next === '\uFF9E') && dakuten[character]) {
      result += dakuten[character];
      index++;
      continue;
    }
    if ((next === 'ﾟ' || next === '\uFF9F') && handakuten[character]) {
      result += handakuten[character];
      index++;
      continue;
    }
    if (character === 'ﾞ' || character === '\uFF9E') {
      result += '゛';
      continue;
    }
    if (character === 'ﾟ' || character === '\uFF9F') {
      result += '゜';
      continue;
    }

    result += character;
  }

  return result;
}

function applyFullWidthToInput($input) {
  const element = $input.get(0);
  const value = $input.val() || '';
  const converted = toFullWidthCharacters(value);

  if (converted !== value && element) {
    const start = element.selectionStart;
    const end = element.selectionEnd;
    const nextStart = start == null ? null : toFullWidthCharacters(value.slice(0, start)).length;
    const nextEnd = end == null ? null : toFullWidthCharacters(value.slice(0, end)).length;
    $input.val(converted);
    if (start != null && document.activeElement === element && typeof element.setSelectionRange === 'function') {
      element.setSelectionRange(nextStart, nextEnd);
    }
  }

  return converted;
}

function containsHalfwidthCharacters(value) {
  return /[ -~\uFF61-\uFF9F]/.test(value == null ? '' : String(value));
}

function syncFullwidthFieldError($input) {
  const invalid = containsHalfwidthCharacters($input.val());
  let $error = $input.next('.fullwidth-error');

  if (!invalid) {
    $error.remove();
    return false;
  }

  if (!$error.length) {
    $error = $('<div class="text-danger small fullwidth-error"></div>');
    $input.after($error);
  }
  $error.text('全角で入力してください。');
  return true;
}

window.toFullWidthCharacters = toFullWidthCharacters;
window.applyFullWidthToInput = applyFullWidthToInput;
window.containsHalfwidthCharacters = containsHalfwidthCharacters;
window.syncFullwidthFieldError = syncFullwidthFieldError;

function formatZipcode(value) {
  let digits = value.replace(/[^0-9]/g, '');

  if (digits.length <= 3) {
    return digits;
  }
  return digits.slice(0, 3) + '-' + digits.slice(3);
}

$(document).on('click', '.bill-sheet-collapse', function(e) {
  if ($(this).data('showing')) {
    $(this).find('.arrow-up').removeClass('d-none');
    $(this).find('.arrow-down').addClass('d-none');
    $(this).data('showing', false);
    $('#bill-items').addClass('d-none');
  } else {
    $(this).find('.arrow-up').addClass('d-none');
    $(this).find('.arrow-down').removeClass('d-none');
    $(this).data('showing', true);
    $('#bill-items').removeClass('d-none');
  }
  $('.bill_sheet_bill_items_contract_start_date .datepicker-js').daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
    drops: 'up',
  });

  $('.bill_sheet_bill_items_contract_start_date .datepicker-js').on('apply.daterangepicker', function(ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    $(this).val(picker.startDate.format(format));
    var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
    clearIcon.css('display', this.value ? 'inline' : 'none');
    let endDate = $(this).closest('.input-clearable').next().find('.datepicker-js').val();
    if (new Date($(this).val()) > new Date(endDate)) {
      $(this).addClass('is-invalid');
      $('.bill-item-date-error-msg').removeClass('d-none');
    } else {
      $(this).closest('.nested-fields').find('.is-invalid').removeClass('is-invalid');
      $('.bill-item-date-error-msg').addClass('d-none');
    }
  });

  $('.bill_sheet_bill_items_contract_start_date .datepicker-js').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  $('.bill_sheet_bill_items_contract_end_date .datepicker-js').daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
    drops: 'up',
  });

  $('.bill_sheet_bill_items_contract_end_date .datepicker-js').on('apply.daterangepicker', function(ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    $(this).val(picker.startDate.format(format));
    var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
    clearIcon.css('display', this.value ? 'inline' : 'none');
    let startDate = $(this).closest('.input-clearable').prev().find('.datepicker-js').val();
    if (new Date($(this).val()) < new Date(startDate)) {
      $(this).addClass('is-invalid');
      $('.bill-item-date-error-msg').removeClass('d-none');
    } else {
      $(this).closest('.nested-fields').find('.is-invalid').removeClass('is-invalid');
      $('.bill-item-date-error-msg').addClass('d-none');
    }
  });

  $('.bill_sheet_bill_items_contract_end_date .datepicker-js').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });
  updateBillAllPrices();
});

function calcItemTotalFee(isChangeTotalTaxDefault = false) {
  let inputValue = $('#bill_sheet_total_fee_without_tax').val();
  const isPayFull = $('#bill_sheet_is_pay_full').prop('checked');
  if (inputValue && ['normal', 'segmented'].includes($('#bill_sheet_bill_type').val())) {
    const projectId = $('[data-project-id]').first().attr('data-project-id');
    const currentBillSheetId = $('[data-bill-sheet-id]').first().attr('data-bill-sheet-id') || null;
    // Try to get ordered_item_id from hidden form field first, then from data attribute
    const orderedItemId = $('#bill_sheet_ordered_item_id').val() ||
      $('[data-ordered-item-id]').first().attr('data-ordered-item-id') ||
      null;

    // When is_pay_full is false, calculate tax from inputValue and subtract existing bill sheets tax
    if (!isPayFull) {
      let inputValueNum = parseInt(inputValue.replaceAll(',', '')) || 0;
      let total_tax = Math.round(inputValueNum * 0.1) || 0;
      let total = inputValueNum + total_tax;
      $('.js-forpayment-consumption-tax').html(formatCurrency(total_tax));
      $('.js-total_fee').html(formatCurrency(total));
      $('#bill_sheet_total_fee').val(total);
      return;
    }

    // When is_pay_full is true, use existing logic (calculate from bill items)
    let has_free_tax = false;
    let total_without_free_tax = 0;
    let total_project_tax = 0;

    $('.nested-fields:not([style*="display: none"]) .js_total_price').each(function() {
      if ($(this).closest('.parent-fields').find('.bill-level-select').length == 0 ||
        ($(this).closest('.parent-fields').find('.bill-level-select').length != 0 && $(this).closest('.parent-fields').find('.bill-level-select').val() === '')) {
        const value = parseInt(this.value.replaceAll(',', '')) || 0;
        const valueTax = parseInt(this.value.replaceAll(',', '')) * 0.1 || 0;
        const isFreeTexas = $(this).closest('.parent-fields').find('.js_is_freetax').val() === 'true';

        if (isFreeTexas) {
          has_free_tax = true;
        } else {
          total_without_free_tax += value;
          total_project_tax += valueTax;
        }
      }
    });

    if (projectId) {
      $.ajax({
        url: `/projects/${projectId}/check_bill_sheets`,
        method: 'GET',
        dataType: 'json',
        async: false,
        data: {
          current_bill_sheet_id: currentBillSheetId,
          ordered_item_id: orderedItemId,
        },
        success: function(response) {
          let total_tax;
          if (response.has_bill_sheets) {
            let existing_bill_sheets_tax = response.total_tax;
            total_tax = total_project_tax - existing_bill_sheets_tax;
            total_tax = Math.round(total_tax);
            total_tax = Object.is(total_tax, -0) ? 0 : total_tax;
          } else {
            total_tax = Math.round(total_project_tax);
            total_tax = Object.is(total_tax, -0) ? 0 : total_tax;
          }
          let total = parseInt(inputValue.replaceAll(',', '')) + total_tax;
          $('.js-forpayment-consumption-tax').html(formatCurrency(total_tax));

          if (isChangeTotalTaxDefault) {
            $('.js-consumption-tax').html(formatCurrency(Math.round(total_project_tax)));
            $('#bill_sheet_total_fee').val(parseInt(inputValue.replaceAll(',', '')) + total_project_tax);
          }
          $('.js-total_fee').html(formatCurrency(total));
          $('#bill_sheet_total_fee').val(total);

        },
        error: function() {
          let total_tax;
          if (has_free_tax) {
            total_tax = Math.round(total_without_free_tax * 0.1) || 0;
          } else {
            total_tax = Math.round(parseInt(inputValue.replaceAll(',', '')) * 0.1) || 0;
          }

          let total = parseInt(inputValue.replaceAll(',', '')) + total_tax;
          $('.js-forpayment-consumption-tax').html(formatCurrency(total_tax));
          $('.js-total_fee').html(formatCurrency(total));
          $('#bill_sheet_total_fee').val(total);
        },
      });
    } else {
      let total_tax;
      if (has_free_tax) {
        total_tax = Math.round(total_without_free_tax * 0.1) || 0;
      } else {
        total_tax = Math.round(parseInt(inputValue.replaceAll(',', '')) * 0.1) || 0;
      }
      let total = parseInt(inputValue.replaceAll(',', '')) + total_tax;
      $('.js-forpayment-consumption-tax').html(formatCurrency(total_tax));
      $('.js-consumption-tax').html(formatCurrency(total_tax));
      $('.js-total_fee').html(formatCurrency(total));
      $('#bill_sheet_total_fee').val(total);
    }
  } else {
    // Use lease calculation method for lease_company and lease_client
    const billType = $('#bill_sheet_bill_type').val();
    const isLease = billType === 'lease_company' || billType === 'lease_client';
    const { total, total_fee, consumption_tax } = isLease ? calculateFeesLease() : calculateFees();

    // Update both consumption tax displays with the same value
    $('.js-consumption-tax').html(formatCurrency(consumption_tax));
    $('.js-forpayment-consumption-tax').html(formatCurrency(consumption_tax));
    $('.js-total_fee').html(formatCurrency(total_fee));
    $('#bill_sheet_total_fee').val((total_fee).toLocaleString('en-US'));
  }
}

$(document).on('change', '#bill_sheet_is_pay_full', function(e) {
  let has_free_tax = false;
  const billType = $('#bill_sheet_bill_type').val();
  $('.nested-fields:not([style*="display: none"]) .js_is_freetax').each(function() {
    if ($(this).val() === 'true') {
      has_free_tax = true;
      return false;
    }
  });

  if (has_free_tax && !$(this).is(':checked') && ['normal', 'segmented'].includes(billType)) {
    alert('非課税商品を含む案件では\n分割請求はご利用いただけません。');
    $(this).prop('checked', true);
    return false;
  }
  updateBillSheetContentByPayFull($(this).prop('checked'));
  let oldValue = parseInt($('#bill_sheet_total_fee_without_tax').data('value')) || 0;
  let remainVal = $('#remain_value').data('remain') || 0;
  let totalBillItem = $('.js-total-amount').data('value') || 0;
  if ($(this).prop('checked')) {
    if ($('#bill_sheet_bill_type').val() == 'lease_company' || $('#bill_sheet_bill_type').val() == 'lease_client') {
      $('#bill_sheet_total_fee_without_tax').val((totalBillItem).toLocaleString('en-US'));
      $('#remain_value').html(`￥` + (remainVal - totalBillItem).toLocaleString('en-US'));
    } else {
      $('#bill_sheet_total_fee_without_tax').val((remainVal + oldValue).toLocaleString('en-US'));
      $('#remain_value').html(`￥` + (remainVal + oldValue).toLocaleString('en-US'));
    }
    $('#bill_sheet_total_fee_without_tax').attr('readonly', true);
    calcItemTotalFee();
  } else {
    $('#bill_sheet_total_fee_without_tax').val(0);
    $('.js-forpayment-consumption-tax').html(formatCurrency(0));
    // $('.js-consumption-tax').html(formatCurrency(0));
    $('.js-total_fee').html(formatCurrency(0));
    $('#bill_sheet_total_fee_without_tax').attr('readonly', false);
    $('#remain_value').html(`￥${remainVal.toLocaleString('en-US')}`);
  }
  // if ($(this).prop('checked')) {
  //   $(this).data('old-value') = $('#bill_sheet_total_fee_without_tax').data('value') || 0;
  //   $('#bill_sheet_total_fee_without_tax').val($('#remain_value').data('remain'));
  //   $('#bill_sheet_total_fee_without_tax').attr('readonly', false)
  // } else {
  //   $('#bill_sheet_total_fee_without_tax').val($(this).data('old-value') || 0)
  //   $('#bill_sheet_total_fee_without_tax').attr('readonly', false)
  // }
});

function updateBillSheetContentByPayFull(isPayFull) {
  const $content = $('#bill_sheet_content');
  if (!$content.length) return;

  if (isPayFull) {
    const originalContent = $content.data('original-content');
    if (originalContent !== undefined) {
      $content.val(originalContent);
    }
  } else {
    $content.data('original-content', $content.val());
    $content.val('分割請求');
  }
}

$(document).on('change', '#bill_sheet_total_fee_without_tax', function() {
  let oldValue = $(this).data('value') || 0;
  let newValue = parseInt($(this).val().replaceAll(',', '')) || 0;
  let remainVal = $('#remain_value').data('remain') || 0;
  remainVal = remainVal + oldValue - newValue;
  $('#remain_value').html(`￥${remainVal.toLocaleString('en-US')}`);
  $('#bill_sheet_is_pay_full').data('current-value', $(this).val().replaceAll(',', ''));
  calcItemTotalFee();
});

$(document).on('click', '#modal-bill-sheet-submit', function(event) {
  event.preventDefault();
  const $button = $(this);
  $button.prop('disabled', true);
  submitBillSheetForm($button);
});

$(document).on('click', '#modal-bill-sheet-save-reissue', function(event) {
  event.preventDefault();
  const $button = $(this);
  $button.prop('disabled', true);
  submitBillSheetForm($button, { reissue: true });
});

$(document).on('click', '#check-duplicate-bill-sheet', function(event) {
  event.preventDefault();
  const $button = $(this);
  const form = getBillSheetForm();

  $button.prop('disabled', true);
  clearAllErrors();

  validateBillSheetForm(form)
    .done(function() {
      const projectId = $('#bill_sheet_project_id').val();
      const billingMonth = $('#bill_sheet_billing_month_pr_continue').val();

      checkDuplicateBillSheet(projectId, billingMonth)
        .always(function() {
          $button.prop('disabled', false);
        });
    })
    .fail(function(xhr) {
      handleBillSheetValidationErrors(xhr);
      $button.prop('disabled', false);
    });
});

$(document).on('click', '#confirm-bill-sheet-submit', function() {
  const $button = $(this);
  const form = getBillSheetForm();

  $button.prop('disabled', true);
  clearAllErrors();

  validateBillSheetForm(form)
    .done(function() {
      $('#modal-bill-sheet-submit').click();
    })
    .fail(function(xhr) {
      handleBillSheetValidationErrors(xhr);
      $button.prop('disabled', false);
    });
});


$(document).on('change', '.money-field', function() {
  var value_input = $(this).val();
  if (value_input != '') {
    value_input = value_input.replace(',', '');
    value_input = convertToHalf(value_input);
  }
  if (isNumeric(value_input.toString())) {
    $(this).val(value_input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
  } else {
    $(this).val(0);
  }
});

// $(document).on('input', '.integer-currency-input', function(e) {
//   const value = $(this).val();
//   // console.log(value.includes('。'))
//   const sanitized = value.replace(/[.。]/g, '');
//   if (value !== sanitized) {
//     e.preventDefault();
//   }
// });

let isComposing = false;

$(document)
  .on('keydown', '.integer-currency-input', function(e) {
    if (e.key === '.' || e.key === '。') {
      e.preventDefault();
      $(this).val($(this).val().replace(/[.。]/g, ''));
    }
  })
  .on('input', '.integer-currency-input', function() {
    const cleaned = $(this).val().replace(/[.。]/g, '');
    $(this).val(cleaned);
  });

function isNumeric(str) {
  if (typeof str != 'string') return false;
  return !isNaN(str) && !isNaN(parseFloat(str));
}

$(document).on('select2:select', function(e) {
  let values = $(e.target).val();
  if (!Array.isArray(values)) {
    return;
  }

  if (values.includes('')) {
    values = values.filter(function(value) {
      return value !== '';
    });
    $(e.target).val(values).change();
  }
});
$(document).on('click', '.multiple-upload-file-editable .btn-done', function(e) {
  e.preventDefault();
  $container = $(this).closest('.file');
  $container.find('.btn-edit').removeClass('d-none');
  $container.find('.btn-delete').removeClass('d-none');
  $container.find('.view-input-file-name').removeClass('d-none');
  $container.find('.btn-done').addClass('d-none');
  $container.find('.input-file-name').addClass('d-none');
});

$(document).on('click', '.multiple-upload-file-editable .btn-edit', function(e) {
  e.preventDefault();
  $container = $(this).closest('.file');
  $container.find('.btn-edit').addClass('d-none');
  $container.find('.btn-delete').addClass('d-none');
  $container.find('.btn-done').removeClass('d-none');
  $container.find('.view-input-file-name').addClass('d-none');
  $container.find('.input-file-name').removeClass('d-none');
});

$(document).on('change', '.multiple-upload-file-editable .input-file-name', function(e) {
  new_values = [];
  value = $(this).val();
  var id = $(this).data('id');

  $(this).closest('.file').find('.view-input-file-name').html(value);
  $('.multiple-upload-file-editable .input-file-name').each(function(index, element) {
    value = $(this).val();
    old_file_name = $(this).attr('data-old-filename');
    if (value.length != 0 && value !== old_file_name) {
      new_values.push(`${id}_${old_file_name} -> ${value}`);
    }
  });
  $(this).closest('.tab-pane').find('.update_file_names').val(new_values.join(','));
});

$(document).on('click', '.multiple-upload-file-editable .btn-delete', function(e) {
  e.preventDefault();
  $container = $(this).closest('.file');
  $container.find('[type=\'checkbox\']').prop('checked', true);
  $(this).closest('.file').addClass('d-none');
});

function createTempfile(file) {
  formData = new FormData();
  formData.append('file[]', file, file.name);

  $.ajax({
    url: '/attachments/upload_tempfile',
    method: 'POST',
    body: formData,
    success: function(res) {
      return res;
    },
  });
}

$(document).on('change', '.multiple-upload-file-editable .multiple-upload-file', function(e) {
  var files = this.files;
  $container = $(this).closest('.multiple-upload-file-editable');
  $listFile = $container.find('.list-files');
  $newFilesAdded = $listFile.find('.isNewFile');
  // $newFilesAdded.remove()

  if (files.length > 10) {
    alert('アップロードは10ファイルまで入力してください。');
    $(this).val('');
    return false;
  } else {
    var file;
    for (var i = 0; i < files.length; i++) {
      file = files[i];

      if (file.size > 20 * 1024 * 1024) {
        alert('各ファイルのサイズは20MBを超えてはならない。');
        $(this).val('');
        // $listFile.html('');
        break;
      } else {
        file_name = file.name;
        $containerTemp = $container.find('[data-file-templete]');
        $containerTemp.find('.add_fields')[0].click();
        // $fileTemplete = $containerTemp.find('.file');
        $fileTemplete = $container.find('.isCreating');

        var tempId = $containerTemp.attr('id');
        $fileTemplete.find('.input-file-name').attr('value', file_name).attr('data-old-filename', file_name);
        $fileTemplete.find('.view-input-file-name').html(file_name);
        $fileTemplete.find('.btn-preview').attr('href', (window.URL || window.webkitURL).createObjectURL(file));
        $remote_file_url = $fileTemplete.find('.remote_file_url');

        // add random string to file
        new_id = Math.random().toString(36).substring(7);
        $remote_file_url.attr('id', new_id);
        $fileTemplete.removeClass('isCreating').addClass('isNewFile'); // add isNewFile class to new file
        formData = new FormData();
        formData.append('file', file, file.name);
        $.ajax({
          url: '/attachments/upload_tempfile?selector_id=' + new_id,
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function(response) {
            old_delete_tempfiles = window.delete_tempfiles_val || [];
            old_delete_tempfiles.push(response.absolute_url || (location.protocol + '//' + location.host + response.path));
            window.delete_tempfiles_val = old_delete_tempfiles;
            $('#delete_tempfiles').val(old_delete_tempfiles.join(','));
            // Prefer local file assignment via temp_path to avoid HTTP download
            if ($('#' + response.selector_id).closest('.file').find('.temp_path').length) {
              // set temp_path for server-side attach
              $('#' + response.selector_id).closest('.file').find('.temp_path').val(response.path);
            } else {
              // fallback: remote_file_url
              var uploadedUrl = response.absolute_url || response.path;
              if (!/^https?:\/\//i.test(uploadedUrl)) {
                uploadedUrl = location.protocol + '//' + location.host + uploadedUrl;
              }
              $('#' + response.selector_id).val(uploadedUrl);
            }
          },
          error: function(xhr, status, error) {
            console.error(error);
          },
        });
        // $listFile.append($fileTemplete.prop('outerHTML'));
        // $fileTemplete.remove();
      }
    }
  }
  $(this).val('');
});

$(document).on('click', '#showDialogImportKorabo', function(e) {
  e.preventDefault();
  $('#modalImportKorabo').modal('show');
});

$(document).on('click', '#showDialogImportKoraboNtt', function(e) {
  e.preventDefault();
  $('#modalImportKoraboNtt').modal('show');
});

$(document).on('click', '#modalImportKoraboError .btn-override_bill_sheet', function(e) {
  if ($(this).attr('data') == 'bill_sheets_exist') {
    e.preventDefault();
    $('#korabo_override_bill_sheet').val('true');
    $('form #modalImportKorabo input[type="submit"]').click();
  }
});

function koraboEnableSubmitUploadBtn() {
  $('#korabo_override_bill_sheet').val('false');
  var hasFile = $('#korabo_csv_path')[0].files.length > 0;
  var dateVal = ($('#korabo_date').val() || '').trim();
  var datePattern = /^\d{4}\/\d{2}\/\d{2}$/; // YYYY/MM/DD
  var isFormatOk = datePattern.test(dateVal);
  var isDateOk = false;
  if (isFormatOk) {
    var parts = dateVal.split('/');
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    var dt = new Date(y, m - 1, d);
    isDateOk = dt.getFullYear() === y && (dt.getMonth() + 1) === m && dt.getDate() === d;
  }

  if (dateVal && !(isFormatOk && isDateOk)) {
    $('#korabo_date').addClass('has-error')[0]?.setCustomValidity?.('日付はYYYY/MM/DD形式で入力してください。');
    $('#korabo-date-error').show();
  } else {
    $('#korabo_date').removeClass('has-error')[0]?.setCustomValidity?.('');
    $('#korabo-date-error').hide();
  }

  if (hasFile && isFormatOk && isDateOk) {
    $('.btn-submit-korabo').prop('disabled', false);
  } else {
    $('.btn-submit-korabo').prop('disabled', true);
  }
}

function koraboNttEnableSubmitUploadBtn() {
  var input = $('.korabo-ntt-files')[0] || $('#korabo_ntt_files')[0];
  var hasFile = input && input.files.length > 0;
  $('.btn-submit-korabo-ntt').prop('disabled', !hasFile);
}

// Helper function to format currency with proper negative sign placement
function formatCurrency(amount) {
  if (amount < 0) {
    return '-￥' + Math.abs(amount).toLocaleString('en-US');
  } else {
    return '￥' + amount.toLocaleString('en-US');
  }
}

$(function() {
  $('#korabo_date').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('YYYY/MM/DD'));
    koraboEnableSubmitUploadBtn();
  });

  $('#korabo_ntt_date').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('YYYY/MM/DD'));
    koraboNttEnableSubmitUploadBtn();
  });

  $('#korabo_date').on('input', function() {
    var v = $(this).val().replace(/[^0-9\/]/g, '').replace(/\/{2,}/g, '/');
    v = v.replace(/^(\d{4})(\d)/, '$1/$2').replace(/^(\d{4}\/\d{2})(\d)/, '$1/$2').slice(0, 10);
    if ($(this).val() !== v) $(this).val(v);
    koraboEnableSubmitUploadBtn();
  }).on('blur change', function() {
    koraboEnableSubmitUploadBtn();
  });
  $('#korabo_ntt_date').on('input', function() {
    var v = $(this).val().replace(/[^0-9\/]/g, '').replace(/\/{2,}/g, '/');
    v = v.replace(/^(\d{4})(\d)/, '$1/$2').replace(/^(\d{4}\/\d{2})(\d)/, '$1/$2').slice(0, 10);
    if ($(this).val() !== v) $(this).val(v);
    koraboNttEnableSubmitUploadBtn();
  }).on('blur change', function() {
    koraboNttEnableSubmitUploadBtn();
  });
});

$(document).on('change', '#korabo_csv_path', function(e) {
  $('.file-choosed').html(this.files[0].name);
  koraboEnableSubmitUploadBtn();
});

$(document).on('change', '.korabo-ntt-files, #korabo_ntt_files', function(e) {
  var names = Array.from(this.files || []).map(function(file) {
    return file.name;
  });
  $('.korabo-ntt-files-choosed').html(names.join('<br>'));
  koraboNttEnableSubmitUploadBtn();
});

$(document).on('hidden.bs.modal', '#modalImportKorabo', function(e) {
  $('#korabo_csv_path').val('');
  $('#korabo_date').val('');
  $('.file-choosed').html('');
  $('.simple_form.korabo input[type="submit"]').prop('disabled', true);
  $('#korabo_override_bill_sheet').val('false');
});

$(document).on('hidden.bs.modal', '#modalImportKoraboNtt', function(e) {
  $('.korabo-ntt-files, #korabo_ntt_files').val('');
  $('#korabo_ntt_date').val('');
  $('.korabo-ntt-files-choosed').html('');
  koraboNttEnableSubmitUploadBtn();
});

$(document).on('shown.bs.modal', '#modalImportKoraboNtt', function(e) {
  koraboNttEnableSubmitUploadBtn();
});

$(document).on('click', '.btn-copy', function(e) {
  e.preventDefault();
  copy_content = $(this).data('copy-content');
  var $temp = $('<input id=\'copyInput\' class=\'d-none\'>');
  $('body').append($temp);
  $temp.val(copy_content);
  var copyText = document.getElementById('copyInput');

  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices
  navigator.clipboard.writeText(copyText.value);
  $temp.remove();
});

$(document).ready(function() {
  $('[data-go-order-screen]').attr('disabled', 'disabled');
  $(document).on('click', '.checkbox-estimate-item, .toggle-check-all-object', function(e) {
    if ($(this).closest('.modal-body').find('.checkbox-estimate-item:checked').length > 0) {
      $(this).closest('.modal-body').find('[data-go-order-screen]').removeAttr('disabled');
    } else {
      $(this).closest('.modal-body').find('[data-go-order-screen]').attr('disabled', 'disabled');
    }
  });

  $(document).on('mousedown', '.select2-container', function(e) {
    e.stopPropagation();
  });

  function isEnhancedEnterTabForm(currentElement) {
    return $(currentElement).closest('.form-enter-tab').attr('data-enter-focus-textarea') === 'true';
  }

  function formEnterTabTargets(currentElement) {
    var $form = $(currentElement).closest('.form-enter-tab');

    return $form.find('input, select, textarea, button').filter(function() {
      var $field = $(this);
      return ($field.is(':visible') || $field.hasClass('select2-hidden-accessible')) &&
        !$field.is(':disabled') &&
        $field.attr('data-skip-enter-focus') !== 'true' &&
        $field.attr('type') !== 'hidden';
    });
  }

  function focusSelect2SearchInput() {
    setTimeout(function() {
      var $searchInput = $('.select2-container--open .select2-search__field').last();
      if ($searchInput.length) {
        $searchInput.trigger('focus');
      }
    }, 0);
  }

  function focusSelect2Selection($field) {
    setTimeout(function() {
      var $selection = $field.next('.select2-container').find('.select2-selection').first();
      if ($selection.length) {
        $selection.trigger('focus');
      }
    }, 0);
  }

  function focusEnterTabField($field, options) {
    options = options || {};

    if ($field.hasClass('select2-hidden-accessible') && $field.data('select2')) {
      if (options.openSelect2 === false) {
        focusSelect2Selection($field);
        return true;
      }

      $field.select2('open');
      focusSelect2SearchInput();
      return true;
    }

    var focusField = function() {
      $field.focus();

      if ($field.is(':radio')) {
        $field.prop('checked', true);
      }
    };

    if (options.deferFocus) {
      setTimeout(focusField, 0);
      return true;
    }

    focusField();
    return true;
  }

  function legacyFocusNextInput(currentElement) {
    var $form = $(currentElement).closest('.form-enter-tab');
    var $inputs = $form.find('input, select, button').filter(function() {
      var $field = $(this);
      return ($field.is(':visible') || $field.hasClass('select2-hidden-accessible')) &&
        !$field.is(':disabled') &&
        $field.attr('type') !== 'hidden';
    });
    var currentInputIndex = $inputs.index(currentElement);

    if (currentInputIndex + 1 < $inputs.length) {
      var nextElement = $inputs.eq(currentInputIndex + 1);

      if (nextElement.hasClass('select2-hidden-accessible')) {
        focusEnterTabField(nextElement);
        return;
      }

      nextElement.focus();

      if (nextElement.is(':radio')) {
        nextElement.prop('checked', true);
      }
    } else {
      $inputs.eq(0).focus();
    }
  }

  function focusNextInput(currentElement) {
    if (!isEnhancedEnterTabForm(currentElement)) {
      legacyFocusNextInput(currentElement);
      return true;
    }

    var $inputs = formEnterTabTargets(currentElement);
    var currentInputIndex = $inputs.index(currentElement);

    if (currentInputIndex + 1 < $inputs.length) {
      var nextElement = $inputs.eq(currentInputIndex + 1);
      return focusEnterTabField(nextElement, { openSelect2: false, deferFocus: true });
    } else {
      return focusEnterTabField($inputs.eq(0), { openSelect2: false, deferFocus: true });
    }
  }

  function isEnterKeyEvent(event) {
    return event.key === 'Enter' || event.which === 13 || event.keyCode === 13;
  }

  function isImeCompositionEvent(event) {
    var originalEvent = event.originalEvent || event;

    return originalEvent.isComposing === true ||
      originalEvent.keyCode === 229 ||
      originalEvent.which === 229 ||
      $(event.target).data('imeComposing') === true;
  }

  function shouldMoveFocusByEnter(event) {
    return isEnterKeyEvent(event) &&
      !event.shiftKey &&
      !event.ctrlKey &&
      !event.altKey &&
      !event.metaKey &&
      !isImeCompositionEvent(event);
  }

  function isSubmitControl(element) {
    var $element = $(element);
    return $element.is('button[type=submit], input[type=submit]');
  }

  function shouldAdvanceSelectedSelect2($select) {
    return $select.attr('data-enter-selected-next') === 'true' && !!$select.val();
  }

  function shouldAdvanceSelect2AfterSelection($select) {
    return $select.attr('data-enter-selected-next') === 'true';
  }

  function select2ElementFromSelection(selectionElement) {
    var $container = $(selectionElement).closest('.select2-container');
    return $container.prev('select.select2-hidden-accessible');
  }

  function blurSelect2Selection($select) {
    $select.next('.select2-container').find('.select2-selection, .select2-selection__clear').trigger('blur');
  }

  function focusConfiguredEnterNextTarget($field) {
    var targetSelector = $field.attr('data-enter-next-target');
    if (!targetSelector) {
      return false;
    }

    var $target = $(targetSelector).first();
    if (!$target.length || $target.is(':disabled')) {
      return false;
    }

    if ($target.hasClass('select2-hidden-accessible') && $target.data('select2')) {
      return focusEnterTabField($target);
    } else {
      $target.trigger('focus');
    }

    return true;
  }

  function focusEnterNextInput($field) {
    if (focusConfiguredEnterNextTarget($field)) {
      return true;
    }

    return focusNextInput($field[0]);
  }

  function forceFocusNextInputAfterSelect2($select) {
    $select.removeData('select2ClosedByEnter');
    $select.removeData('advanceFocusAfterSelect2Close');

    var focused = false;
    [0, 20, 60].forEach(function(delay) {
      setTimeout(function() {
        if (focused) {
          return;
        }

        blurSelect2Selection($select);
        focused = focusEnterNextInput($select);
      }, delay);
    });
  }

  function moveFocusFromSelectedSelect2($select) {
    $select.removeData('select2ClosedByEnter');
    return focusEnterNextInput($select);
  }

  function isOpenSelect2($select) {
    return $select.data('select2') && $select.data('select2').isOpen();
  }

  function handleClosedSelect2Enter($select) {
    if (isOpenSelect2($select)) {
      return false;
    }

    if ($select.data('select2ClosedByEnter')) {
      $select.removeData('select2ClosedByEnter');
      return focusNextInput($select[0]);
    }

    if (shouldAdvanceSelectedSelect2($select)) {
      return moveFocusFromSelectedSelect2($select);
    }

    var hasOptions = $select.children('option').length > 0;
    if (!hasOptions) {
      return focusNextInput($select[0]);
    }

    $select.select2('open');
    focusSelect2SearchInput();
    return true;
  }

  function handleLegacyEnterNavigation(event, currentElement) {
    if (event.which !== 13 && !isEnterKeyEvent(event)) {
      return;
    }

    event.preventDefault();
    if ($(currentElement).hasClass('select2-hidden-accessible')) {
      var select2Element = $(currentElement);
      var hasOptions = select2Element.children('option').length > 0;
      if (!hasOptions) {
        focusNextInput(currentElement);
        return;
      }
    }

    focusNextInput(currentElement);
  }

  // $(document).on('select2:opening', '.form-enter-tab select', function(e) {
  //     if ($(this).data('prevent-open')) {
  //         $(this).removeData('prevent-open');
  //         e.preventDefault();
  //     }
  // }).on('focus', '.form-enter-tab select', function(e) {
  //     if ($(this).hasClass('select2-hidden-accessible')) {
  //         $(this).data('prevent-open', true);
  //     }
  // });

  $(document)
    .on('compositionstart', '.form-enter-tab[data-enter-focus-textarea="true"] input, .form-enter-tab[data-enter-focus-textarea="true"] textarea', function() {
      $(this).data('imeComposing', true);
    })
    .on('compositionend', '.form-enter-tab[data-enter-focus-textarea="true"] input, .form-enter-tab[data-enter-focus-textarea="true"] textarea', function() {
      var element = this;
      $(element).data('imeComposing', true);
      setTimeout(function() {
        $(element).data('imeComposing', false);
      }, 0);
    });

  $(document).on('keydown', '.form-enter-tab[data-enter-focus-textarea="true"] input, .form-enter-tab[data-enter-focus-textarea="true"] select, .form-enter-tab[data-enter-focus-textarea="true"] textarea, .form-enter-tab[data-enter-focus-textarea="true"] button', function(event) {
    if (shouldMoveFocusByEnter(event)) {
      if (isSubmitControl(this)) {
        return;
      }

      event.preventDefault();
      if ($(this).hasClass('select2-hidden-accessible')) {
        handleClosedSelect2Enter($(this));
        return;
      }

      focusNextInput(this);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (!shouldMoveFocusByEnter(event)) {
      return;
    }

    var selectionElement = $(event.target).closest('.select2-selection')[0];
    if (!selectionElement) {
      return;
    }

    var $select = select2ElementFromSelection(selectionElement);
    if (!$select.length || !shouldAdvanceSelectedSelect2($select)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    moveFocusFromSelectedSelect2($select);
  }, true);

  $(document).on('keypress', '.form-enter-tab:not([data-enter-focus-textarea="true"]) input:not([type=checkbox]):not([type=radio]), .form-enter-tab:not([data-enter-focus-textarea="true"]) button', function(event) {
    handleLegacyEnterNavigation(event, this);
  });

  $(document).on('keydown', '.form-enter-tab:not([data-enter-focus-textarea="true"]) select, .form-enter-tab:not([data-enter-focus-textarea="true"]) input[type=checkbox], .form-enter-tab:not([data-enter-focus-textarea="true"]) input[type=radio]', function(event) {
    handleLegacyEnterNavigation(event, this);
  });

  $(document).on('keydown', '.select2-container--open .select2-search__field', function(event) {
    if (!shouldMoveFocusByEnter(event)) {
      return;
    }

    var $highlightedOption = $('.select2-results__option--highlighted').first();
    var hasSelectableOption = $highlightedOption.length &&
      $highlightedOption.attr('aria-disabled') !== 'true' &&
      !$highlightedOption.hasClass('loading-results');

    if (hasSelectableOption) {
      return;
    }

    var $openSelect = $('.form-enter-tab[data-enter-focus-textarea="true"] select.select2-hidden-accessible').filter(function() {
      return $(this).data('select2') && $(this).data('select2').isOpen();
    }).first();

    if (!$openSelect.length) {
      return;
    }

    event.preventDefault();
    $openSelect.data('skipEnterTabClose', true);
    $openSelect.select2('close');
    focusNextInput($openSelect[0]);
  });

  function isSelect2KeyboardEnterEvent(event) {
    var originalEvent = event.params && event.params.args && event.params.args.originalEvent;
    return originalEvent && shouldMoveFocusByEnter(originalEvent);
  }

  $(document).on('select2:selecting', '.form-enter-tab select', function(e) {
    if (isSelect2KeyboardEnterEvent(e)) {
      if (isEnhancedEnterTabForm(this) && shouldAdvanceSelect2AfterSelection($(this))) {
        $(this).data('advanceFocusAfterSelect2Close', true);
      } else if (isEnhancedEnterTabForm(this)) {
        // For enhanced forms, mark that selection was made by Enter key
        // but don't advance focus immediately
        $(this).data('select2ClosedByEnter', true);
      } else {
        // Legacy behavior: advance immediately
        $(this).data('advanceFocusAfterSelect2Close', true);
      }
    }
  });

  $(document).on('select2:select', '.form-enter-tab select[data-enter-selected-next="true"]', function() {
    if (isEnhancedEnterTabForm(this)) {
      forceFocusNextInputAfterSelect2($(this));
    }
  });

  $(document).on('select2:close', '.form-enter-tab select', function(e) {
    var $select = $(this);

    if (isEnhancedEnterTabForm(this) && $select.data('skipEnterTabClose')) {
      $select.removeData('skipEnterTabClose');
      return;
    }

    if (isEnhancedEnterTabForm(this)) {
      if ($select.data('advanceFocusAfterSelect2Close')) {
        $select.removeData('advanceFocusAfterSelect2Close');
        $select.removeData('select2ClosedByEnter');
        setTimeout(function() {
          forceFocusNextInputAfterSelect2($select);
        }, 0);
        return;
      }

      // For enhanced forms, keep focus on the select element after closing
      // User will press Enter again to move to next field
      if ($select.data('select2ClosedByEnter')) {
        setTimeout(function() {
          $select.focus();
        }, 0);
      }
      return;
    }

    // Legacy behavior
    if ($(this).data('advanceFocusAfterSelect2Close')) {
      $(this).removeData('advanceFocusAfterSelect2Close');
      focusNextInput(this);
    }
  });

  $(document).on('change', '.form-enter-tab select:not(.select2-hidden-accessible)', function() {
    focusNextInput(this);
  });

  $(document).on('shown.bs.modal', '#modal-choose-ordered-item', function() {
    update_datepicker();
  });

  $(document).on('hidden.bs.modal', '#modal-choose-ordered-item', function() {
    resetChooseOrderedItemModal();
  });

  $(document).on('shown.bs.modal', '#modal-create-bill-sheet', function() {
    update_datepicker();
  });

  $(document).on('shown.bs.modal', '#problem-client-comapny-form', function() {
    update_datepicker();
  });

  function update_datepicker() {
    $('.datepicker-js').on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
      clearIcon.css('display', this.value ? 'inline' : 'none');
    });
  }
});

function styleVisibleMonthYearPicker(container) {
  var $pickers = container ? $(container) : $('.daterangepicker:visible');
  $pickers.each(function() {
    var $picker = $(this);
    var $left = $picker.find('.drp-calendar.left');
    var $month = $left.find('select.monthselect').first();
    var $year = $left.find('select.yearselect').first();
    if (!$month.length || !$year.length) return;

    $picker.find('.drp-calendar.right').hide();
    $left.css({ width: '100%', float: 'none' });

    var $cell = $month.closest('th.month');
    var $row = $cell.children('.month-year-row');
    if (!$row.length) {
      $row = $('<div class="month-year-row"></div>');
      $cell.append($row);
    }
    if (!$row.children('.datepicker-year').length) {
      $row.append('<div class="datepicker-year">年</div>');
    }
    $row.css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      direction: 'ltr'
    });
    var $kanji = $row.children('.datepicker-year');
    $row.append($year);
    $row.append($kanji);
    $row.append($month);

    $year.css({
      width: '78px',
      minWidth: '78px',
      float: 'none',
      display: 'inline-block',
      textAlign: 'center',
      textAlignLast: 'center',
      verticalAlign: 'middle',
      padding: '4px 6px',
      boxSizing: 'border-box'
    });
    $month.css({
      width: '72px',
      minWidth: '72px',
      float: 'none',
      display: 'inline-block',
      textAlign: 'center',
      textAlignLast: 'center',
      verticalAlign: 'middle',
      padding: '4px 6px',
      boxSizing: 'border-box'
    });
    $kanji.css({
      float: 'none',
      display: 'inline-block',
      textAlign: 'center',
      verticalAlign: 'middle'
    });
    $cell.css('text-align', 'center');
    $left.find('.table-condensed > tbody').hide();
    $left.find('.table-condensed > thead').children('tr').eq(1).hide();
  });
}

function initDateRangePickerMonthYear() {
  $('input.singledate-month-year').each(function(i, obj) {
    if ($(obj).data('daterangepicker')) return;

    var parentSelector = $(obj).attr('data-daterangepicker-parent');
    $(obj).daterangepicker({
      locale: ja_date_locale_month_year,
      singleDatePicker: true,
      autoUpdateInput: !$(obj).is('#q_payment_period_months_eq'),
      showDropdowns: true,
      parentEl: parentSelector ? $(parentSelector) : $(obj).parent(),
      isCustomDate: function() {
        styleVisibleMonthYearPicker();
      },
    });

    $(obj).on('hide.daterangepicker', function(ev, picker) {
      var $box = picker && picker.container ? $(picker.container) : $(this).parent();
      let month = parseInt($box.find('.monthselect :selected').val(), 10) + 1;
      let year = $box.find('.yearselect :selected').val();
      let format = $(this).data('format') || 'YYYY/MM/DD';
      $(this).data('daterangepicker').setStartDate(year + '/' + month);
      $(this).val(picker.startDate.format(format));
      var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
      clearIcon.css('display', this.value ? 'inline' : 'none');
      if ($(this).closest('#bill_sheet_month').length > 0) {
        $('#choose-bill-sheet-month-submit').prop('disabled', this.value ? false : true);
      }
    });

    $(obj).on('cancel.daterangepicker', function(ev, picker) {
      $(this).val('');
    });

    $(obj).on('show.daterangepicker', function(ev, picker) {
      styleVisibleMonthYearPicker(picker.container);
      window.setTimeout(function() {
        styleVisibleMonthYearPicker(picker.container);
      }, 0);
      $(picker.container).off('change.monthYearClose').on('change.monthYearClose', function(e) {
        if (!$(e.target).is('select.monthselect, select.yearselect')) return;
        var format = $(obj).data('format') || 'YYYY/MM/DD';
        // The picker redraws its selects before this delegated handler runs.
        picker.setStartDate(picker.leftCalendar.month.clone().startOf('month'));
        $(obj).val(picker.startDate.format(format));
        var clearIcon = $(obj).closest('.input-clearable').find('.clear-icon');
        clearIcon.css('display', $(obj).val() ? 'inline' : 'none');
        if ($(obj).closest('#bill_sheet_month').length > 0) {
          $('#choose-bill-sheet-month-submit').prop('disabled', false);
        }
        picker.hide();
      });
    });
  });


  $(document).on('change', '.checked-final', function() {
    $(this).prop('disabled', true);
    var item_id = $(this).val();

    var is_ordered = $(this).data('is-ordered');
    if (is_ordered && !confirm('受注を解除してもよろしいですか。')) {
      $(this).prop('checked', true);
      $(this).prop('disabled', false);
      return;
    }
    var url = '';
    if (is_ordered) {
      url = `/ordered_items/${item_id}/change_to_estimate_sheet`;

      $.ajax({
        url: url,
        method: 'PUT',
        success: function(res) {
          location.reload();
        },
      });
    } else {
      $('#ordered-date-modal').modal('show');
      $('#ordered-date-modal .help-block-error').text('');
      $('#ordered_item_id').val(item_id);
      var fullDate = new Date();
      var month = fullDate.getMonth() + 1;
      month = month < 10 ? '0' + month : String(month);
      var day = fullDate.getDate() + '';
      if (day.length == 1) day = '0' + day;
      var currentDate = fullDate.getFullYear() + '/' + month + '/' + day;
      $('#input_ordered_date').val(currentDate);
    }
  });

  function parseDate(dateStr) {
    let parts = dateStr.split('/');
    if (parts.length !== 3) return false;

    let day = parseInt(parts[2], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[0], 10);

    return isValidDate(year, month, day);
  }

  function isValidDate(year, month, day) {
    let date = new Date(year, month - 1, day);
    return date.getFullYear() === year && (date.getMonth() + 1) === month && date.getDate() === day;
  }

  $(document).on('click', '.js-save-ordered-date', function() {
    var ordered_date = $('#input_ordered_date').val();
    var item_id = $('#ordered_item_id').val();
    var datePattern = /^\d{4}\/\d{2}\/\d{2}$/;
    var is_valid_date = parseDate(ordered_date);
    if (!ordered_date) {
      $('#input_ordered_date').addClass('has-error');
      $('#ordered-date-modal .help-block-error').text('このフィールドは必須です。');
      return;
    }

    if (!datePattern.test(ordered_date) || !is_valid_date) {
      $('#input_ordered_date').addClass('has-error');
      $('#ordered-date-modal .help-block-error').text('日付の正しい形式は「yyyy/mm/dd」入力してください。');
      return;
    }
    if (ordered_date && item_id) {
      $('#input_ordered_date').removeClass('has-error');
      $('#ordered-date-modal .help-block-error').text('');
      url = `/estimate_sheets/${item_id}/change_to_ordered?ordered_date=${ordered_date}`;
      const newUrl = window.location.origin + window.location.pathname + '?current_tab=ordered-item-tab';
      window.history.replaceState(null, null, newUrl);
      $.ajax({
        url: url,
        method: 'PUT',
        success: function(res) {
          location.reload();
        },
      });

      $('#ordered-date-modal').modal('hide');
    } else {
      $('#input_ordered_date').addClass('has-error');
      $('#ordered-date-modal .help-block').text('このフィールドは必須です。');
    }
  });

  $(document).on('click', '#ordered-date-modal .btn-custom-cancel, #ordered-date-modal .btn-close', function() {
    $('.check-final-ordered-item').each(function() {
      $(this).prop('checked', false);
      $(this).prop('disabled', false);
    });
    $('#input_ordered_date').removeClass('has-error');
    $('#ordered-date-modal .help-block').text('');
  });

  $(document).on('click', '#search_address', function() {
    var zipcode = $($(this).data('zipcode')).val();
    var address = $($(this).data('address'));
    var error = $($(this).data('error'));

    $.ajax({
      url: '/main_companies/find_zipcode',
      data: { zipcode: zipcode },
      method: 'get',
      dataType: 'json',
      success: function(res) {
        if (res.status) {
          address.val(res.data.prefecture + res.data.city + res.data.town);
          error.find('.help-block').remove();
          error.removeClass('has-error');
        } else {
          error.addClass('has-error');
          error.find('.help-block').remove();
          error.append('<span class="help-block">入力された郵便番号が存在しません。再度確認してください。</span>');
          address.val('');
        }
      },
    });
  });

  $(document).on('change', '.bank_account_id_select', function() {
    var bank_account_id = $(this).val();
    var ele = $(this);
    $.ajax({
      url: '/main_companies/get_bank_info',
      data: { id: bank_account_id },
      method: 'get',
      dataType: 'json',
      success: function(res) {
        if (res.status) {
          var data_res = res.data.table;
          ele.closest('table').find('.account_number').html(data_res.account_number);
          ele.closest('table').find('.bank-id').html(data_res.bank_name);
          ele.closest('table').find('.holder_name_kanji').html(data_res.holder_name_kanji);
          ele.closest('table').find('.branch_id').html(data_res.branch_name);
          ele.closest('table').find('.holder_name_katakana').html(data_res.holder_name_katakana);
          ele.closest('table').find('.bank_type').html(data_res.account_type == 'normal' ? '普通' : '当座');
        } else {
          // $('#main_company_prefecture').val('');
        }
      },
    });
  });

  function openImagePreview(image_id) {
    const imageSrc = document.getElementById(image_id).src;
    const modal = document.createElement('div');
    modal.classList.add('image-modal');
    modal.innerHTML = `
      <div class="image-modal-overlay""></div>
      <div class="image-modal-content">
        <img src="${imageSrc}" alt="Preview Image">
        <button class="image-modal-close"">✖</button>
      </div>
    `;
    document.body.appendChild(modal);
  }

  $(document).on('click', '.btn-view', function() {
    openImagePreview('image-preview-logo');
  });
  $(document).on('click', '.btn-view-stamp', function() {
    openImagePreview('preview-stamp');
  });

  $(document).on('click', '.image-modal-close', function() {
    $('.image-modal').remove();
  });

  $(document).on('change', '#file-upload-logo', function(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        $('#image-preview-logo').attr('src', e.target.result);

        $('#image-preview-container').removeClass('d-none');
        $('#file-upload-container').addClass('d-none');
      };
      reader.readAsDataURL(file);
    }
  });

  $(document).on('change', '#file-upload', function(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        $('#preview-stamp').attr('src', e.target.result);

        $('#image-preview-stamp').removeClass('d-none');
        $('#file-upload-stamp').addClass('d-none');
      };
      reader.readAsDataURL(file);
    }
  });

  $(document).on('click', '.close-button', function() {
    $('#image-preview-container').addClass('d-none');
    $('#file-upload-container').removeClass('d-none');
  });


  $(document).on('click', '.btn-delete-logo', function() {
    $(this).closest('.logo-group').find('.text-danger').remove();
    $('#file-upload-logo').val('');
    $('#image-preview-logo').attr('src', '');
    $('#image-preview-container').addClass('d-none');
    $('#file-upload-container').removeClass('d-none');
    $('#main_company_logo_cache').val('');
    $(this).closest('.logo-group').find('#main_company_remove_logo').val(true);
    if ($('.logo-group').find('.text-danger').length > 0) {
      $('.btn-save').prop('disabled', true);
    } else {
      $('.btn-save').prop('disabled', false);
    }
  });

  $(document).on('click', '.btn-delete-stamp', function() {
    $(this).closest('.logo-group').find('.text-danger').remove();
    $('#file-upload').val('');
    $('#preview-stamp').attr('src', '');
    $('#image-preview-stamp').addClass('d-none');
    $('#file-upload-stamp').removeClass('d-none');
    $(this).closest('.logo-group').find('#main_company_remove_company_stamp').val(true);
    $('#main_company_company_stamp_cache').val('');
    if ($('.logo-group').find('.text-danger').length > 0) {
      $('.btn-save').prop('disabled', true);
    } else {
      $('.btn-save').prop('disabled', false);
    }
  });

  $(document).on('click', '.btn-logo', function(e) {
    e.preventDefault();
    $('#file-upload-logo').trigger('click');
  });

  $(document).on('click', '.btn-stamp', function(e) {
    e.preventDefault();
    $('#file-upload').trigger('click');
  });

  $(document).on('cocoon:after-insert', '#main_company_bank_accounts', function(e, insertedItem) {
    const bankAccountId = $('#bank_defualt_id').val();

    check_is_default(bankAccountId);
  });

  $(document).on('cocoon:after-remove', '#main_company_bank_accounts', function(e, insertedItem) {
    if (insertedItem.find('.checkbox-is-default').is(':checked')) {
      var bank_id = insertedItem.find('.checkbox-is-default').data('id');
      $('#bank_defualt_id').val('');
      const bankAccountId = $('#bank_defualt_id').val();

      check_is_default(bankAccountId);
    }
  });

  $(document).on('change', '.checkbox-is-default', function() {
    var bank_id = $(this).data('id');
    if ($(this).is('checked')) {
      $('#bank_defualt_id').val(bank_id || '');
    } else {
      $('#bank_defualt_id').val('');
    }
    check_is_default($('#bank_defualt_id').val());
  });

  function check_is_default(bankAccountId) {
    if (bankAccountId === '') {
      const checkboxes = $('.checkbox-is-default:visible');
      const hasChecked = checkboxes.is(':checked');

      if (!hasChecked) {
        checkboxes.prop('disabled', false);
      } else {
        checkboxes.each(function() {
          if ($(this).is(':checked')) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true);
          }
        });
      }
    } else {
      $('.checkbox-is-default').each(function() {
        if ($(this).data('id') == bankAccountId) {
          $(this).prop('disabled', false);
        } else {
          $(this).prop('disabled', true);
        }
      });
    }
  }

  $(document).on('change', '#main_company_select', function() {
    const main_company_id = $(this).val();
    $element = $(this);

    $.ajax({
      url: `/main_companies/${main_company_id}/bank_accounts`,
      type: 'GET',
      success: function(e) {
        let default_id = null;
        let bank_name = '';
        let data = e.data.map(function(item) {
          if (item.table.is_default) {
            default_id = item.table.id;
            bank_name = item.table.bank_name;
          }
          return { id: item.table.id, text: item.table.bank_account_id };
        });

        $bank_account_id = $element.closest('.department-table').find('#department_bank_account_id');

        $bank_account_id.empty();
        $bank_account_id.select2({
          width: '100%',
          theme: 'bootstrap',
          placeholder: '選択してください',
          allowClear: true,
          data: data,
          language: {
            noResults: function() {
              return '見つかりません。';
            },
          },
          dropdownParent: $('#modal-department'),
        });
        $bank_account_id.val(default_id).trigger('change');
        $('#bank_name').val(bank_name);
      },
    });
  });

  $(document).on('change', '#department_bank_account_id', function() {
    const bank_account_id = $(this).val();

    $.ajax({
      url: '/main_companies/get_bank_info',
      data: { id: bank_account_id },
      method: 'get',
      dataType: 'json',
      success: function(res) {
        if (res.status) {
          var data_res = res.data.table;
          $('#bank_name').val(data_res.bank_name).trigger('change');
        } else {
          $('#bank_name').val('').trigger('change');
        }
      },
    });
  });
}


$(document).ready(function() {
  $('.convert-half-width').attr('inputmode', 'numeric').attr('autocomplete', 'off');
  $('.convert-half-width-text').attr('autocomplete', 'off');
});

$(document).on('shown.bs.modal', function() {
  $('.js-popover-custom').not($(this)).popover('hide').popover('dispose');
});

$(document).on('click', '.js-remove-pending-document', function() {
  const signedId = $(this).data('blob-signed-id');
  const $form = $(this).closest('form.form-estimate-sheet');
  $form.find('input[name*=\'[documents][]\']').filter(function() {
    return $(this).val() === signedId;
  }).remove();
  $form.find('.upload-item[data-blob-signed-id=\'' + signedId + '\']').remove();
});

$(document).ready(function() {
  setValidateInputDecimal();

  $(document).on('shown.bs.modal', '#lease_company_modal', function() {
    setValidateInputDecimal();
  });
});

$(document).ready(function() {
  $('.search-form input').on('change', function() {
    $(this).val($(this).val().trim());
  });
});

$.fn.inputFilterx = function(callback, errMsg) {
  return this.on('input focusout', function(e) {
    if (callback(this.value)) {
      // Accepted value
      $(this).removeClass('input-error');
      this.setCustomValidity('');
      this.oldValue = this.value;
      this.oldSelectionStart = this.selectionStart;
      this.oldSelectionEnd = this.selectionEnd;
    } else {
      // Rejected value - nothing to restore
      $(this).addClass('input-error');
      this.setCustomValidity(errMsg);
      this.reportValidity();
      this.value = 0;
    }
  });
};

function updatePaymentOption(companyId, paymentOption) {
  $.ajax({
    url: `/companies/${companyId}/load_sending_place`,
    method: 'GET',
    success: function(res) {
      if (paymentOption.val()) return;
      paymentOption.val(res.payment_type).change();
    },
  });
}

$(document).on('change', '.project_company_id #client_company_id', function() {
  updatePaymentOption($('#client_company_id').val(), $('#payment_type'));
});

function setValidateInputDecimal(container = document) {
  $(container).find('.input_decimal').inputFilterx(function(value) {
    return /^[-ー−]?[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁、小数部分は最大2桁です。');

  $(container).find('.input_number, .no-decimal-input').inputFilterx(function(value) {
    return /^[0-9０-９]{0,8}$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁');

  $(container).find('.integer-currency-input').inputFilterx(function(value) {
    return /^[0-9０-９]{0,8}$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁');

  $(container).find('.negative-integer-currency-input').inputFilterx(function(value) {
    var normalized = value.replace(/,/g, '');
    return /^[-\u30FC\u2212\uFF0D]?[0-9０-９]{0,8}$/.test(normalized);
  }, '整数部分は最大8桁');
}

$(document).on('cocoon:after-insert', function(e, insertedItem) {
  setValidateInputDecimal(insertedItem);
});

$(document).on('cocoon:after-insert', '#form-estimate-nested-sell-price', function(e, insertedItem) {
  let $wrapNestedElm = $(insertedItem).closest('.nested-fields');
  $wrapNestedElm.find('.input_decimal').inputFilterx(function(value) {
    return /^[-ー−]?[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁、小数部分は最大2桁です。');

  $wrapNestedElm.find('.input_number, .no-decimal-input').inputFilterx(function(value) {
    return /^[0-9０-９]{0,8}$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁');
});

$(document).on('cocoon:after-insert', '#form-estimate-nested-cost', function(e, insertedItem) {
  let $wrapNestedElm = $(insertedItem).closest('.nested-fields');
  $wrapNestedElm.find('.input_decimal').inputFilterx(function(value) {
    return /^[-ー−]?[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁、小数部分は最大2桁です。');

  $wrapNestedElm.find('.input_number, .no-decimal-input').inputFilterx(function(value) {
    return /^[0-9０-９]{0,8}$/.test(value.replace(/,/g, ''));
  }, '整数部分は最大8桁');
});

$(document).on('shown.bs.modal', function() {
  $('[data-bs-toggle="tooltip"]').tooltip({
    container: 'body',
  });
});


window.formatNumberToCurrency = function(num) {
  return Number(num) % 1 === 0 ? parseInt(num) : parseFloat(num);
};


//Dont allow open daterangepicker popup picker when selecting Select2 input
$(document).on('select2:opening', function() {
  if ($('.daterangepicker').is(':visible')) {
    $('input.singledate-month-year').each(function(i, obj) {
      const picker = $(obj).data('daterangepicker');
      if (picker && picker.isShowing) {
        picker.hide();
      }
    });
  }
});

$(document).on('click', '#estimate-lease-tab, #ordered-item-tab, #order-tab, #bill-tab', function() {
  $('#estimate').removeClass('show active');
});

$(document).ready(function() {
  // Handle menu with 2 levels: if there is a li.active, open the parent menu
  $('.sidebar-dropdown-container ul li').each(function() {
    if ($(this).hasClass('active')) {
      var $container = $(this).closest('.sidebar-dropdown-container');
      $container.show();
      $container.siblings('.sidebar-dropdown-btn.level-1').addClass('active');
    }
  });
});

$(document).on('input', '.no-numbers', function() {
  this.value = this.value.replace(/\d/g, '');
});

function getBillSheetForm() {
  return $('#modal-create-bill-sheet').find('form');
}

function handleBillSheetValidationErrors(xhr, options = {}) {
  const reShowCreateModal = options.reShowCreateModal !== false;
  if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
    if (reShowCreateModal) {
      $('#modal-confirm-duplicate-bill-sheet').modal('hide');
      $('#modal-create-bill-sheet').modal('show');
    }

    clearAllErrors();
    Object.keys(xhr.responseJSON.errors).forEach(function(field) {
      showFieldError(field, xhr.responseJSON.errors[field]);
    });

    return true;
  }

  const message = xhr.responseJSON?.message || '保存中にエラーが発生しました。もう一度お試しください。';
  alert(message);
  return false;
}

function validateBillSheetForm(form) {
  return $.ajax({
    url: '/bill_sheets/validate',
    type: 'POST',
    data: $(form).serialize(),
    dataType: 'json',
  });
}

function checkDuplicateBillSheet(projectId, billingMonth) {
  return $.ajax({
    url: `/bill_sheets/get_bill_sheets_same_billing_month_ps_continue?project_id=${projectId}&billing_month_pr_continue=${billingMonth}`,
    method: 'GET',
    dataType: 'script',
  });
}

function downloadBillSheetPdf(url) {
  return fetch(url, { credentials: 'same-origin' }).then(function(response) {
    const contentType = response.headers.get('content-type') || '';
    if (!response.ok || (!contentType.includes('application/pdf') && !contentType.includes('application/zip'))) {
      throw new Error('請求書PDFを再発行できませんでした。');
    }

    const disposition = response.headers.get('content-disposition') || '';
    const utf8Filename = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    let filename = '請求書.pdf';
    if (utf8Filename) {
      try {
        filename = decodeURIComponent(utf8Filename[1]);
      } catch (_error) {
        filename = '請求書.pdf';
      }
    }

    return response.blob().then(function(blob) {
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(function() {
        window.URL.revokeObjectURL(objectUrl);
      }, 0);
    });
  });
}

function submitBillSheetForm($button, options = {}) {
  const form = getBillSheetForm();
  clearAllErrors();

  return $.ajax({
    url: $(form).attr('action'),
    type: 'POST',
    data: $(form).serialize(),
    dataType: 'json',
  }).done(function() {
    const $modal = $('#modal-create-bill-sheet');
    const returnUrl = $modal.attr('data-return-url');
    const reissueUrl = $modal.attr('data-reissue-url');

    if (options.reissue && reissueUrl) {
      downloadBillSheetPdf(reissueUrl)
        .then(function() {
          window.location.assign(returnUrl || window.location.href);
        })
        .catch(function(error) {
          if (window.Swal) {
            window.Swal.fire({ icon: 'error', text: error.message });
          } else {
            alert(error.message);
          }
        });
      return;
    }

    if (returnUrl) {
      window.location.assign(returnUrl);
      return;
    }

    const url = new URL(window.location.href);
    const isBillSheetPage = url.pathname === '/bill_sheets';
    const hasBillTab = url.searchParams.get('current_tab') === 'bill-tab';

    if (isBillSheetPage || hasBillTab) {
      window.location.reload();
    } else {
      url.searchParams.set('current_tab', 'bill-tab');
      window.location.assign(url.toString());
    }
  }).fail(function(xhr) {
    handleBillSheetValidationErrors(xhr);
  }).always(function() {
    if ($button) {
      $button.prop('disabled', false);
    }
    $('#modal-bill-sheet-submit').prop('disabled', false);
    $('#modal-bill-sheet-save-reissue').prop('disabled', false);
    $('#check-duplicate-bill-sheet').prop('disabled', false);
    $('#confirm-bill-sheet-submit').prop('disabled', false);
  });
}

function clearAllErrors() {
  $('#modal-create-bill-sheet .invalid-feedback').remove();
  $('#modal-create-bill-sheet .has-error').removeClass('has-error');
  $('.form-group .text-danger, .help-block, .alert-danger').remove();
  $('.is-invalid').removeClass('is-invalid');
  $('.js-bill-payment-summary-error').removeData('messages').addClass('d-none').empty();
}

function showFieldError(fieldName, errorMessages) {
  if (['total_fee', 'total_fee_without_tax'].includes(fieldName)) {
    showBillSheetSummaryError(errorMessages);
    return;
  }

  const fieldMappings = {
    'bill_date': '#bill_sheet_bill_date',
    'expired_at': '#bill_sheet_expired_at',
    'deposit_date': '#bill_sheet_deposit_date',
    'content': '#bill_sheet_content',
    'total_fee_without_tax': '#bill_sheet_total_fee_without_tax',
    'total_fee': '#bill_sheet_total_fee',
    'sending_place_id': '#bill_sheet_sending_place_id',
    'bank_account_id': '#payment-condition-bank-account, #bill_sheet_bank_account_id',
    'pay_method': '#payment-condition-pay-method, #bill_sheet_pay_method',
    'note': '#payment-condition-note',
  };

  if (fieldName.includes('bill_items[')) {
    handleBillItemError(fieldName, errorMessages);
    showBillItemsErrorMessage();
    return;
  }

  const selector = fieldMappings[fieldName] || `#bill_sheet_${fieldName}`;
  const $field = $(selector);

  if ($field.length > 0) {
    $field.addClass('is-invalid');
    const errorHtml = `<div class="invalid-feedback d-block">${errorMessages.join(', ')}</div>`;
    const $select2Container = $field.next('.select2-container');

    if ($select2Container.length > 0) {
      $select2Container.find('.select2-selection').addClass('has-error');
      $select2Container.after(errorHtml);
    } else {
      $field.after(errorHtml);
    }
  }
}

function handleBillItemError(fieldName, errorMessages) {
  const matches = fieldName.match(/bill_items\[(\d+)\]\[(\w+)\]/);
  if (matches) {
    const index = matches[1];
    const field = matches[2];

    const $targetField = $(`[name="bill_sheet[bill_items_attributes][${index}][${field}]"]`);

    if ($targetField.length > 0) {
      $targetField.addClass('is-invalid');
      const errorHtml = `<div class="invalid-feedback d-block">${errorMessages.join(', ')}</div>`;
      $targetField.after(errorHtml);
    } else {
      const $billItemRow = $(`.bill-item-fields`).eq(index);
      if ($billItemRow.length > 0) {
        let $fieldInRow;

        switch (field) {
          case 'amount':
            $fieldInRow = $billItemRow.find('input[name*="[amount]"]');
            break;
          case 'name':
            $fieldInRow = $billItemRow.find('input[name*="[name]"]');
            break;
          case 'price':
            $fieldInRow = $billItemRow.find('input[name*="[price]"]');
            break;
          default:
            $fieldInRow = $billItemRow.find(`input[name*="[${field}]"]`);
        }

        if ($fieldInRow.length > 0) {
          $fieldInRow.addClass('is-invalid');
        }
      }
    }
  }
}

function showBillSheetSummaryError(errorMessages) {
  const $summaryError = $('.js-bill-payment-summary-error');
  if ($summaryError.length === 0) return;

  const existingMessages = ($summaryError.data('messages') || []).map(String);
  const nextMessages = errorMessages.map(String);
  const mergedMessages = [...new Set(existingMessages.concat(nextMessages))];

  $summaryError
    .data('messages', mergedMessages)
    .text(mergedMessages.join(', '))
    .removeClass('d-none');
}

function showBillItemsErrorMessage() {
  $('.bill-error-msg').removeClass('d-none').text('フィールド「項目／摘要」「数量」「単価」は必須項目です。ご確認ください');
}

window.initDateRangePickerMonthYear = initDateRangePickerMonthYear;

function autoSearchSubmitButton(form) {
  const preferred = form.querySelector(
    'input[type="submit"].btn-submit, button[type="submit"].btn-submit, input[type="submit"].problem-filter-submit-button, button[type="submit"].problem-filter-submit-button'
  );
  if (preferred && !preferred.hasAttribute('formaction')) return preferred;

  const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    if (button.hasAttribute('formaction')) continue;
    if (button.classList.contains('problem-filter-excel-button')) continue;
    if (button.classList.contains('problem-filter-export-button')) continue;
    return button;
  }
  return null;
}

function scheduleAutoSearch($form) {
  if (!$form || !$form.length || $form.data('autoSearchSubmitting')) return;

  clearTimeout($form.data('autoSearchTimer'));
  $form.data('autoSearchTimer', setTimeout(function() {
    if ($form.data('autoSearchSubmitting')) return;

    const form = $form[0];
    if (!form) return;

    $form.data('autoSearchSubmitting', true);
    const button = autoSearchSubmitButton(form);
    if (typeof form.requestSubmit === 'function') {
      try {
        form.requestSubmit(button || undefined);
        return;
      } catch (e) {
        $form.data('autoSearchSubmitting', false);
      }
    }

    if (button) {
      button.click();
    } else {
      form.submit();
    }
  }, 80));
}

function scheduleAutoSearchIfDateChanged($input) {
  const previous = $input.data('autoSearchPrev');
  const next = $input.val() || '';
  if (previous !== undefined && String(previous) === String(next)) return;

  $input.data('autoSearchPrev', next);
  scheduleAutoSearch($input.closest('.js-auto-search-form'));
}

$(document).on('change', '.js-auto-search-form select', function(event) {
  if ($(this).hasClass('select2-hidden-accessible')) return;
  if (!event.originalEvent) return;
  scheduleAutoSearch($(this).closest('.js-auto-search-form'));
});

$(document).on('select2:opening', '.js-auto-search-form select', function() {
  $(this).data('autoSearchPrev', JSON.stringify($(this).val()));
});

$(document).on('select2:close', '.js-auto-search-form select', function() {
  const $select = $(this);
  const previous = $select.data('autoSearchPrev');
  if (previous === undefined) return;

  const next = JSON.stringify($select.val());
  $select.removeData('autoSearchPrev');
  if (previous === next) return;
  scheduleAutoSearch($select.closest('.js-auto-search-form'));
});

$(document).on('select2:clear select2:unselect', '.js-auto-search-form select', function() {
  scheduleAutoSearch($(this).closest('.js-auto-search-form'));
});

$(document).on('change', '.js-auto-search-form input[type="radio"], .js-auto-search-form input[type="checkbox"]', function(event) {
  if (!event.originalEvent) return;
  scheduleAutoSearch($(this).closest('.js-auto-search-form'));
});

function bindAutoSearchDateInput($input) {
  if (!$input.closest('.js-auto-search-form').length) return;

  $input.off('.autoSearchDate');
  $input.on('show.daterangepicker.autoSearchDate', function() {
    $(this).data('autoSearchPrev', $(this).val() || '');
  });
  $input.on('apply.daterangepicker.autoSearchDate cancel.daterangepicker.autoSearchDate', function() {
    const $current = $(this);
    setTimeout(function() {
      scheduleAutoSearchIfDateChanged($current);
    }, 0);
  });
  $input.on('hide.daterangepicker.autoSearchDate', function() {
    if (!$(this).hasClass('singledate-month-year')) return;

    const $current = $(this);
    setTimeout(function() {
      scheduleAutoSearchIfDateChanged($current);
    }, 0);
  });
}

$(document).on('focusin', '.js-auto-search-form input', function() {
  const $input = $(this);
  if ($input.data('autoSearchPrev') === undefined) {
    $input.data('autoSearchPrev', $input.val() || '');
  }
  bindAutoSearchDateInput($input);
});

$(function() {
  setTimeout(function() {
    $('.js-auto-search-form input').each(function() {
      bindAutoSearchDateInput($(this));
    });
  }, 0);
});

$(document).on('click', '.js-auto-search-form .clear-icon', function() {
  if ($(this).hasClass('disabled') || $(this).attr('aria-disabled') === 'true') return;

  const $input = $(this).closest('.input-clearable').find('input').not('[type="radio"],[type="checkbox"]').first();
  if ($input.length && $input.prop('disabled')) return;
  scheduleAutoSearch($(this).closest('.js-auto-search-form'));
});
$(document).ready(function() {
  var $form = $('.companies-form');
  if ($form.length === 0) return;

  var $firstError = $form.find('.has-error, .field_with_errors').first();
  if ($firstError.length > 0) {
    $('html, body').animate({ scrollTop: $firstError.offset().top - 50 }, 50);
  }
});
